import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/arbres-decisionnels-cngoflogo-colhpv2.png'
import _imports_1 from '../assets/logo-cngof.png'
import _imports_2 from '../assets/close.svg'
import _imports_3 from '../assets/home.svg'
import _imports_4 from '../assets/contexte.svg'
import _imports_5 from '../assets/references.svg'
import _imports_6 from '../assets/sources.svg'
import _imports_7 from '../assets/definitions.svg'
import _imports_8 from '../assets/plus.svg'
import _imports_9 from '../assets/suggestions1.svg'
import _imports_10 from '../assets/SFC-PCV.png'
import _imports_11 from '../assets/DDC.png'
import _imports_12 from '../assets/ionic-ios-arrow-back.svg'
import _imports_13 from '../assets/nextDark.svg'


const _withScopeId = n => (_pushScopeId("data-v-08c6623f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  href: "cmd://webview-close"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "close"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "empty"
}
const _hoisted_8 = {
  key: 0,
  class: "content"
}
const _hoisted_9 = {
  key: 1,
  class: "content"
}
const _hoisted_10 = { class: "summary-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "dark-blue" }, "Sommaire", -1))
const _hoisted_12 = {
  key: 2,
  class: "content"
}
const _hoisted_13 = { class: "plus" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "dark-blue" }, "Menu principal", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Revenir à l'accueil", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Remerciements", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Préambule", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sommaire", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sources", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Références", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Définitions", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  href: "https://doc.360medics.com/assets/media/cngof/FicheRepereINCAHPVetcancerMai20182.pdf",
  target: "blank",
  class: "sub-section"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "En savoir plus HPV & Cancer", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  key: 1,
  href: "medics://viewer?m_source=https://doc.360medics.com/assets/media/cngof/FicheRepereINCAHPVetcancerMai20182.pdf",
  class: "sub-section"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "En savoir plus HPV & Cancer", -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_9 }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Suggestions d'améliorations", -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 3,
  class: "content"
}
const _hoisted_48 = {
  key: 4,
  class: "content"
}
const _hoisted_49 = {
  key: 5,
  class: "content"
}
const _hoisted_50 = {
  key: 6,
  class: "content"
}
const _hoisted_51 = {
  key: 7,
  class: "content"
}
const _hoisted_52 = {
  key: 8,
  class: "content"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "info bg-gray" }, "Risque immédiat de CIN3+ (ASCUS HPV+)", -1))
const _hoisted_54 = { class: "info-content" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fushia" }, "ASCUS", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("ASCUS HPV+ : "),
    /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "4.4%*")
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("ASCUS HPV16 : "),
    /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "9%*")
  ]),
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ASCUS non 16 non 18 : "),
    /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "4.4%*")
  ])
], -1))
const _hoisted_57 = {
  key: 9,
  class: "content"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "info bg-gray" }, "Risque immédiat de CIN3+ (HPV+)", -1))
const _hoisted_59 = { class: "info-content" }
const _hoisted_60 = /*#__PURE__*/_createStaticVNode("<h3 class=\"fushia\" data-v-08c6623f>LSIL</h3><p data-v-08c6623f><strong data-v-08c6623f>LSIL HPV+ : <span class=\"fushia\" data-v-08c6623f>4.3%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>LSIL HPV 16: <span class=\"fushia\" data-v-08c6623f>11%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>LSIL non 16 non 18 : <span class=\"fushia\" data-v-08c6623f>4.3%*</span></strong></p><h3 class=\"fushia\" data-v-08c6623f>ASC-H</h3><p data-v-08c6623f><strong data-v-08c6623f>ASC-H HPV+ : <span class=\"fushia\" data-v-08c6623f>26%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>ASC-H HPV 16: <span class=\"fushia\" data-v-08c6623f>28%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>ASC-H non 16 non 18 : <span class=\"fushia\" data-v-08c6623f>26%*</span></strong></p><h3 class=\"fushia\" data-v-08c6623f>HSIL</h3><p data-v-08c6623f><strong data-v-08c6623f>HSIL HPV+ : <span class=\"fushia\" data-v-08c6623f>49%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>HSIL HPV 16: <span class=\"fushia\" data-v-08c6623f>60%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>HSIL HPS non 16 non 18 : <span class=\"fushia\" data-v-08c6623f>49%*</span></strong></p>", 6)
const _hoisted_66 = {
  key: 10,
  class: "content"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "info bg-gray" }, "Risque immédiat de CIN3+", -1))
const _hoisted_68 = { class: "info-content" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("AGC HPV+ : "),
    /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "30%*")
  ])
], -1))
const _hoisted_70 = {
  key: 11,
  class: "content"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "info bg-gray" }, "Risque immédiat de CIN3+", -1))
const _hoisted_72 = { class: "info-content" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("CIN3+ HPV négatif : "),
    /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "0.14%*")
  ]),
  /*#__PURE__*/_createTextVNode(" à 5 ans")
], -1))
const _hoisted_74 = {
  key: 12,
  class: "content"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "info bg-gray" }, "Risques de CIN3+ (HPV +)", -1))
const _hoisted_76 = { class: "info-content" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("HPV + cytologie négative : "),
    /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "4.8%*")
  ]),
  /*#__PURE__*/_createTextVNode(" à 5 ans"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "HPV 16+ et/ou 18+ cytologie négative :"),
  /*#__PURE__*/_createTextVNode(" risque immédiat "),
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, " 5.3%*")
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("HPV non 16 non 18 cytologie négative : "),
    /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "4.8%")
  ]),
  /*#__PURE__*/_createTextVNode(" à 5 ans*")
], -1))
const _hoisted_78 = {
  key: 13,
  class: "content"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "info bg-gray" }, "Risques de CIN3+ (HPV +)", -1))
const _hoisted_80 = { class: "info-content" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("Risque à 5 ans : "),
    /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "4.8%*")
  ])
], -1))
const _hoisted_82 = {
  key: 14,
  class: "content"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "info bg-gray" }, "Risques de CIN3+ (HPV négatif)", -1))
const _hoisted_84 = { class: "info-content" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("Risque à 5 ans: "),
    /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "0.12%*")
  ])
], -1))
const _hoisted_86 = {
  key: 15,
  class: "content"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "info bg-gray" }, "Risque immédiat de CIN3+ (HPV+)", -1))
const _hoisted_88 = { class: "info-content" }
const _hoisted_89 = /*#__PURE__*/_createStaticVNode("<h3 class=\"fushia\" data-v-08c6623f>ASCUS</h3><p class=\"info-content\" data-v-08c6623f><strong data-v-08c6623f>ASCUS HPV+ : <span class=\"fushia\" data-v-08c6623f>4.4%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>ASCUS HPV16 : <span class=\"fushia\" data-v-08c6623f>9%*</span></strong><strong data-v-08c6623f><br data-v-08c6623f>ASCUS non 16 non 18 : <span class=\"fushia\" data-v-08c6623f>4.4%*</span></strong></p><h3 class=\"fushia\" data-v-08c6623f>LSIL</h3><p class=\"info-content\" data-v-08c6623f><strong data-v-08c6623f>LSIL HPV+ : <span class=\"fushia\" data-v-08c6623f>4.3%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>LSIL HPV 16: <span class=\"fushia\" data-v-08c6623f>11%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>LSIL non 16 non 18 : <span class=\"fushia\" data-v-08c6623f>4.3%*</span></strong></p><h3 class=\"fushia\" data-v-08c6623f>ASC-H</h3><p class=\"info-content\" data-v-08c6623f><strong data-v-08c6623f>ASC-H HPV+ : <span class=\"fushia\" data-v-08c6623f>26%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>ASC-H HPV 16: <span class=\"fushia\" data-v-08c6623f>28%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>ASC-H non 16 non 18 : <span class=\"fushia\" data-v-08c6623f>26%*</span></strong></p><h3 class=\"fushia\" data-v-08c6623f>AGC</h3><p class=\"info-content\" data-v-08c6623f><strong data-v-08c6623f>AGC : <span class=\"fushia\" data-v-08c6623f>30%*</span></strong></p><h3 class=\"fushia\" data-v-08c6623f>HSIL</h3><p class=\"info-content\" data-v-08c6623f><strong data-v-08c6623f>HSIL HPV+ : <span class=\"fushia\" data-v-08c6623f>49%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>HSIL HPV 16: <span class=\"fushia\" data-v-08c6623f>60%*</span></strong><br data-v-08c6623f><strong data-v-08c6623f>HSIL HPS non 16 non 18 : <span class=\"fushia\" data-v-08c6623f>49%*</span></strong></p><h3 class=\"fushia\" data-v-08c6623f>AIS</h3><p class=\"info-content\" data-v-08c6623f><strong data-v-08c6623f>CIN3+ : <span class=\"fushia\" data-v-08c6623f>0.14%*</span></strong> à 5 ans</p>", 12)
const _hoisted_101 = {
  key: 16,
  class: "content"
}
const _hoisted_102 = /*#__PURE__*/_createStaticVNode("<div data-v-08c6623f><h3 class=\"info bg-green\" data-v-08c6623f>Faire / Ne pas faire</h3><div class=\"info-content\" data-v-08c6623f><h3 class=\"light-green\" data-v-08c6623f>30-65 ans Dépistage HPV négatif, ce qu&#39;il faut faire</h3><ul class=\"f-npf\" data-v-08c6623f><li data-v-08c6623f>Un dépistage HPV à 5 ans, ce qui n’exclut pas le suivi gynécologique régulier</li><li data-v-08c6623f>Exclure de cette orientation les patientes en situation particulière</li></ul><h3 class=\"light-green\" data-v-08c6623f>30-65 ans Dépistage HPV négatif, ce qu&#39;il <span class=\"underline\" data-v-08c6623f>NE FAUT PAS</span> faire</h3><ul class=\"f-npf\" data-v-08c6623f><li data-v-08c6623f>Demander un test HPV de dépistage avant 5 ans (sauf cas exceptionnels de profil à risque ou symptomatiques)</li><li data-v-08c6623f>Pratiquer une cytologie (le cotest n&#39;est pas recommandé en France)</li><li data-v-08c6623f>Confondre dépistage HPV de routine à 5 ans et dépistage en situations particulières</li></ul></div></div>", 1)
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = {
  key: 17,
  class: "content"
}
const _hoisted_105 = /*#__PURE__*/_createStaticVNode("<div data-v-08c6623f><h3 class=\"info bg-green\" data-v-08c6623f>Faire / Ne pas faire</h3><div class=\"info-content\" data-v-08c6623f><h3 class=\"light-green\" data-v-08c6623f>30-65 ans, dépistage HPV positif, ce qu&#39;il faut faire</h3><ul class=\"f-npf\" data-v-08c6623f><li data-v-08c6623f>Un triage cytologique reflex systématique des femmes</li><li data-v-08c6623f>En cas de cytologie négative, reconvoquer la patiente à 12 mois pour test HPV seul (pas de cytologie de triage à ce stade), positif persistant une colposcopie est à réaliser, négatif on passe au dépistage HPV 5 ans plus tard</li><li data-v-08c6623f>Examiner en colposcopie les femmes ASCUS+</li></ul><h3 class=\"light-green\" data-v-08c6623f>30-65 ans, dépistage HPV positif, ce qu&#39;il <span class=\"underline\" data-v-08c6623f>NE FAUT PAS</span> faire</h3><ul class=\"f-npf\" data-v-08c6623f><li data-v-08c6623f>Proposer une cytologie <strong class=\"underline\" data-v-08c6623f>et</strong> un test HPV (Co-test) en dépistage primaire</li><li data-v-08c6623f>Convoquer en consultation la patiente pour la cytologie plutôt que de le réaliser comme <strong data-v-08c6623f>test reflex</strong></li><li data-v-08c6623f>Pratiquer une colposcopie systématique chez une femme ayant un HPV positif (Si information disponible de génotypage les recos US proposent une colposcopie après HPV16, en France pas de recommandation de colposcopie après HPV16)</li><li data-v-08c6623f>Ignorer de réévaluer les patientes après 12 mois</li></ul></div></div>", 1)
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = {
  key: 18,
  class: "content"
}
const _hoisted_108 = /*#__PURE__*/_createStaticVNode("<div data-v-08c6623f><h3 class=\"info bg-green\" data-v-08c6623f>Faire / Ne pas faire</h3><div class=\"info-content\" data-v-08c6623f><h3 class=\"light-green\" data-v-08c6623f>25 à 29 ans inclus, ce qu&#39;il faut faire</h3><ul class=\"f-npf\" data-v-08c6623f><li data-v-08c6623f>Pratiquer à partir de 25 ans 2 cytologies de dépistage à un an d’intervalle puis 3 ans après si le résultat des deux premiers est normal</li><li data-v-08c6623f>Pratiquer un test HPV en cas de cytologie ASCUS, de cytologie AGC ou de cytologie anormale avec colposcopie non satisfaisante</li><li data-v-08c6623f>Demander une colposcopie après ASCUS HPV+</li><li data-v-08c6623f>Demander une colposcopie après LSIL+</li><li data-v-08c6623f>En cas d’ASCUS HPV négatif, prochain dépistage cytologique à 3 ans avant 30 ans et après 30 ans test HPV de dépistage</li></ul><h3 class=\"light-green\" data-v-08c6623f>25 à 29 ans inclus, ce qu&#39;il <span class=\"underline\" data-v-08c6623f>NE FAUT PAS</span> faire</h3><ul class=\"f-npf\" data-v-08c6623f><li data-v-08c6623f>Demander un test HPV en dépistage primaire</li><li data-v-08c6623f>Pratiquer une cytologie de dépistage à un rythme trop rapproché (moins de 3 ans) en dehors des deux premières cytologies de dépistage qu’il faut faire à un an d’intervalle</li><li data-v-08c6623f>Modifier le rythme de dépistage cytologique en fonction du profil vaccinal</li><li data-v-08c6623f>Pratiquer une colposcopie en cas d’ASCUS HPV négatif</li></ul></div></div>", 1)
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = { class: "nav-container" }
const _hoisted_111 = {
  key: 1,
  class: "nav"
}
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { class: "flex" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Préambule", -1))
const _hoisted_116 = [
  _hoisted_115
]
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sommaire", -1))
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "intro-text" }, "Dépistage primaire du cancer du col de l’utérus : aide à la décision", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "justify-content" }, [
  /*#__PURE__*/_createTextVNode("Le test HPV-HR est recommandé par la HAS chez les "),
  /*#__PURE__*/_createElementVNode("strong", null, "femmes à partir de 30 ans"),
  /*#__PURE__*/_createTextVNode(" en remplacement de la cytologie de dépistage (juillet 2019).")
], -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Quel âge a votre patiente ?", -1))
const _hoisted_122 = { class: "age-button-container" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "soutien-container" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Avec le soutien de la SFCPCV"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    class: "soutien"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "et de l'Association Nationale des CRCDC"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    class: "soutien"
  })
], -1))
const _hoisted_124 = { key: 1 }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resp-text orange" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir"),
  /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Dépistage non recommandé à adapter au cas par cas")
], -1))
const _hoisted_126 = { class: "toggle-info bg-gray" }
const _hoisted_127 = /*#__PURE__*/_createTextVNode("Pourquoi le dépistage n'est pas recommandé ?")
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_129 = [
  _hoisted_127,
  _hoisted_128
]
const _hoisted_130 = ["id"]
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Beaucoup d'HPV et peu de lésions,"),
  /*#__PURE__*/_createElementVNode("li", null, "Clairance élevée car jeune âge et infections récentes (infections transitoires ou passagères),"),
  /*#__PURE__*/_createElementVNode("li", null, "Risque de conisations majeures ou de conisations inutiles et délétères")
], -1))
const _hoisted_132 = [
  _hoisted_131
]
const _hoisted_133 = { key: 2 }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Votre dépistage concerne :", -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Dépistage de routine", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_137 = /*#__PURE__*/_createTextVNode("(hors situations particulières)")
const _hoisted_138 = [
  _hoisted_135,
  _hoisted_136,
  _hoisted_137
]
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "center" }, "OU", -1))
const _hoisted_140 = ["id"]
const _hoisted_141 = { class: "toggle-info bg-gray margin-top" }
const _hoisted_142 = /*#__PURE__*/_createTextVNode("Qu'en est-il des femmes vaccinées ?")
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_144 = [
  _hoisted_142,
  _hoisted_143
]
const _hoisted_145 = ["id"]
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "La prévention du cancer du col est une intervention globale qui intègre la vaccination HPV et le dépistage. Ces 2 interventions ont un impact optimal lorsqu'elles sont complémentaires. A ce jour le dépistage des femmes vaccinées doit se poursuivre sans changement.", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "La prévention vaccinale des jeunes filles et des garçons protège durablement et de façon robuste contre les types HPV responsables d’une fraction importantes des cancers dus à ce virus. En France, elle est actuellement indiquée en prévention des lésions pré-cancéreuses et/ou cancéreuses du col de l’utérus, de l’anus, de la vulve et du vagin.", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Le dépistage, qui ne concerne que le col utérin des femmes adultes, a pour objectif de détecter les CIN HG et de prévenir ainsi ce cancer.", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "A ce jour, faute de recul, il n'y a pas de recommandation à modifier le paradigme du dépistage chez les femmes vaccinées. Cependant avec une protection attendue de plus de 85% des CIN HG avec la vaccination utilisée majoritairement en France, on peut anticiper que dans les années à venir le dépistage des femmes vaccinées pourrait démarrer plus tard et sera beaucoup plus espacé. Les modélisations disponibles indiquent que le risque vie résiduel de cancer du col et de conisations chez les femmes dépistées est réduit par 3 chez les vaccinées comparé aux non vaccinées.", -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("em", null, "(LS Valentzis et al Int J Cancer. 2017 Dec 15;141(12):2410-2422 )")
], -1))
const _hoisted_151 = [
  _hoisted_146,
  _hoisted_147,
  _hoisted_148,
  _hoisted_149,
  _hoisted_150
]
const _hoisted_152 = { key: 3 }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resp-text orange" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir"),
  /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Dépistage cytologique seulement")
], -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Quel est le résultat de la "),
  /*#__PURE__*/_createElementVNode("span", { class: "orange" }, "cytologie CU"),
  /*#__PURE__*/_createTextVNode(" ?")
], -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "center" }, "OU", -1))
const _hoisted_156 = { class: "list-button-container" }
const _hoisted_157 = { class: "toggle-info bg-gray margin-top" }
const _hoisted_158 = /*#__PURE__*/_createTextVNode("Qu'en est-il des femmes vaccinées ?")
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_160 = [
  _hoisted_158,
  _hoisted_159
]
const _hoisted_161 = ["id"]
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "La prévention du cancer du col est une intervention globale qui intègre la vaccination HPV et le dépistage. Ces 2 interventions ont un impact optimal lorsqu'elles sont complémentaires. A ce jour le dépistage des femmes vaccinées doit se poursuivre sans changement.", -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "La prévention vaccinale des jeunes filles et des garçons protège durablement et de façon robuste contre les types HPV responsables d’une fraction importantes des cancers dus à ce virus. En France, elle est actuellement indiquée en prévention des lésions pré-cancéreuses et/ou cancéreuses du col de l’utérus, de l’anus, de la vulve et du vagin.", -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Le dépistage, qui ne concerne que le col utérin des femmes adultes, a pour objectif de détecter les CIN HG et de prévenir ainsi ce cancer.", -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "A ce jour, faute de recul, il n'y a pas de recommandation à modifier le paradigme du dépistage chez les femmes vaccinées. Cependant avec une protection attendue de plus de 85% des CIN HG avec la vaccination utilisée majoritairement en France, on peut anticiper que dans les années à venir le dépistage des femmes vaccinées pourrait démarrer plus tard et sera beaucoup plus espacé. Les modélisations disponibles indiquent que le risque vie résiduel de cancer du col et de conisations chez les femmes dépistées est réduit par 3 chez les vaccinées comparé aux non vaccinées.", -1))
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("em", null, "(LS Valentzis et al Int J Cancer. 2017 Dec 15;141(12):2410-2422 )")
], -1))
const _hoisted_167 = [
  _hoisted_162,
  _hoisted_163,
  _hoisted_164,
  _hoisted_165,
  _hoisted_166
]
const _hoisted_168 = { key: 4 }
const _hoisted_169 = { class: "resp-text orange" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Entre 25-30 ans, le dépistage CCU = "),
  /*#__PURE__*/_createElementVNode("strong", { class: "dark-orange" }, "2 cytologies CU négatives à un an d'intervalle"),
  /*#__PURE__*/_createTextVNode(" puis "),
  /*#__PURE__*/_createElementVNode("strong", { class: "dark-orange" }, "1 cytologie 3 ans après"),
  /*#__PURE__*/_createTextVNode(" jusqu'à l'âge de 29 ans révolus.")
], -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_173 = { class: "toggle-info bg-green" }
const _hoisted_174 = /*#__PURE__*/_createTextVNode("Faire / Ne pas faire")
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_176 = [
  _hoisted_174,
  _hoisted_175
]
const _hoisted_177 = { key: 5 }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Avez-vous réalisé un "),
  /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "test HPV"),
  /*#__PURE__*/_createTextVNode(" après cytologie "),
  /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "ASCUS"),
  /*#__PURE__*/_createTextVNode(" ?")
], -1))
const _hoisted_179 = { class: "row-button-container" }
const _hoisted_180 = ["id"]
const _hoisted_181 = { key: 0 }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resp-text fushia" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createElementVNode("strong", { class: "fushia" }, "Pratiquer un Test HPV")
  ])
], -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_184 = { class: "toggle-info bg-green" }
const _hoisted_185 = /*#__PURE__*/_createTextVNode("Faire / Ne pas faire")
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_187 = [
  _hoisted_185,
  _hoisted_186
]
const _hoisted_188 = { key: 6 }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Le résultat du "),
  /*#__PURE__*/_createElementVNode("strong", { class: "fushia" }, "test HPV"),
  /*#__PURE__*/_createTextVNode(" est :")
], -1))
const _hoisted_190 = { class: "row-button-container" }
const _hoisted_191 = ["id"]
const _hoisted_192 = ["id"]
const _hoisted_193 = { key: 0 }
const _hoisted_194 = { class: "resp-text orange" }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Cytologie à 3 ans", -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_199 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_201 = [
  _hoisted_199,
  _hoisted_200
]
const _hoisted_202 = ["id"]
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small-info-content" }, "Arbre décisionnel extrait de l’outil pour la pratique « le dépistage du cancer du col en pratique », INCa 2020", -1))
const _hoisted_205 = { key: 1 }
const _hoisted_206 = { class: "resp-text orange" }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Colposcopie avec biopsie si anomalie", -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_211 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_213 = [
  _hoisted_211,
  _hoisted_212
]
const _hoisted_214 = ["id"]
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small-info-content" }, "Arbre décisionnel extrait de l’outil pour la pratique « le dépistage du cancer du col en pratique », INCa 2020", -1))
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_218 = { class: "toggle-info bg-gray" }
const _hoisted_219 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (ASCUS HPV+)")
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_221 = [
  _hoisted_219,
  _hoisted_220
]
const _hoisted_222 = { key: 7 }
const _hoisted_223 = { class: "resp-text orange" }
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Réaliser une colposcopie avec biopsie si anomalie", -1))
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_228 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_230 = [
  _hoisted_228,
  _hoisted_229
]
const _hoisted_231 = ["id"]
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small-info-content" }, "Arbre décisionnel extrait de l’outil pour la pratique « le dépistage du cancer du col en pratique », INCa 2020", -1))
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_235 = { class: "toggle-info bg-gray" }
const _hoisted_236 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+")
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_238 = [
  _hoisted_236,
  _hoisted_237
]
const _hoisted_239 = { key: 8 }
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Avez-vous réalisé un "),
  /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "test HPV"),
  /*#__PURE__*/_createTextVNode(" après cytologie "),
  /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "AGC"),
  /*#__PURE__*/_createTextVNode(" ?")
], -1))
const _hoisted_241 = { class: "row-button-container" }
const _hoisted_242 = ["id"]
const _hoisted_243 = { key: 0 }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resp-text fushia" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createElementVNode("strong", { class: "fushia" }, "Pratiquer un Test HPV")
  ])
], -1))
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_246 = { class: "toggle-info bg-green" }
const _hoisted_247 = /*#__PURE__*/_createTextVNode("Faire / Ne pas faire")
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_249 = [
  _hoisted_247,
  _hoisted_248
]
const _hoisted_250 = { key: 9 }
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Le résultat du "),
  /*#__PURE__*/_createElementVNode("strong", { class: "fushia" }, "test HPV"),
  /*#__PURE__*/_createTextVNode(" est :")
], -1))
const _hoisted_252 = { class: "row-button-container" }
const _hoisted_253 = ["id"]
const _hoisted_254 = ["id"]
const _hoisted_255 = { key: 0 }
const _hoisted_256 = { class: "resp-text orange" }
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Cytologie à 3 ans", -1))
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_261 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_263 = [
  _hoisted_261,
  _hoisted_262
]
const _hoisted_264 = ["id"]
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small-info-content" }, "Arbre décisionnel extrait de l’outil pour la pratique « le dépistage du cancer du col en pratique », INCa 2020", -1))
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_268 = { class: "toggle-info bg-gray" }
const _hoisted_269 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+")
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_271 = [
  _hoisted_269,
  _hoisted_270
]
const _hoisted_272 = { key: 1 }
const _hoisted_273 = { class: "resp-text orange" }
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Colposcopie et curetage endocervical", -1))
const _hoisted_276 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_278 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_280 = [
  _hoisted_278,
  _hoisted_279
]
const _hoisted_281 = ["id"]
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small-info-content" }, "Arbre décisionnel extrait de l’outil pour la pratique « le dépistage du cancer du col en pratique », INCa 2020", -1))
const _hoisted_284 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_285 = { class: "toggle-info bg-gray" }
const _hoisted_286 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+")
const _hoisted_287 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_288 = [
  _hoisted_286,
  _hoisted_287
]
const _hoisted_289 = { key: 10 }
const _hoisted_290 = { class: "resp-text orange" }
const _hoisted_291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_292 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Test HPV de dépistage", -1))
const _hoisted_293 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Le résultat du "),
  /*#__PURE__*/_createElementVNode("strong", { class: "fushia" }, "test HPV"),
  /*#__PURE__*/_createTextVNode(" est :")
], -1))
const _hoisted_294 = { class: "row-button-container" }
const _hoisted_295 = ["id"]
const _hoisted_296 = { key: 0 }
const _hoisted_297 = { class: "resp-text orange" }
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_299 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Dépistage par un test HPV à 5 ans", -1))
const _hoisted_300 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_301 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_302 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_303 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_304 = [
  _hoisted_302,
  _hoisted_303
]
const _hoisted_305 = ["id"]
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Évaluation de la recherche des papillomavirus humains (HPV) en dépistage primaire des lésions précancéreuses et cancéreuses du col de l’utérus - HAS - 2019", -1))
const _hoisted_307 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_308 = { class: "toggle-info bg-green" }
const _hoisted_309 = /*#__PURE__*/_createTextVNode("Faire / Ne pas faire")
const _hoisted_310 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_311 = [
  _hoisted_309,
  _hoisted_310
]
const _hoisted_312 = { class: "toggle-info bg-gray" }
const _hoisted_313 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+")
const _hoisted_314 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_315 = [
  _hoisted_313,
  _hoisted_314
]
const _hoisted_316 = { key: 11 }
const _hoisted_317 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Test "),
  /*#__PURE__*/_createElementVNode("span", { class: "orange" }, "HPV positif")
], -1))
const _hoisted_318 = { class: "resp-text orange" }
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_320 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, [
  /*#__PURE__*/_createTextVNode("Triage cytologique "),
  /*#__PURE__*/_createElementVNode("span", { class: "underline" }, "réflexe"),
  /*#__PURE__*/_createTextVNode(" (sur le liquide de prélèvement HPV)")
], -1))
const _hoisted_321 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Quel est le résultat de la "),
  /*#__PURE__*/_createElementVNode("span", { class: "orange" }, "cytologie réflexe"),
  /*#__PURE__*/_createTextVNode(" ?")
], -1))
const _hoisted_322 = { class: "list-button-container" }
const _hoisted_323 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "center" }, "OU", -1))
const _hoisted_324 = /*#__PURE__*/_createTextVNode("ASCUS +")
const _hoisted_325 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_326 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-light" }, "(ASCUS, LSIL, ASC-H, AGC, HSIL, AIS)", -1))
const _hoisted_327 = [
  _hoisted_324,
  _hoisted_325,
  _hoisted_326
]
const _hoisted_328 = { key: 12 }
const _hoisted_329 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Test "),
  /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "HPV positif"),
  /*#__PURE__*/_createTextVNode(" et triage cytologique réflexe "),
  /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "négatif")
], -1))
const _hoisted_330 = { class: "resp-text orange" }
const _hoisted_331 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_332 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Test HPV à 1 an", -1))
const _hoisted_333 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_334 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_335 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_336 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_337 = [
  _hoisted_335,
  _hoisted_336
]
const _hoisted_338 = ["id"]
const _hoisted_339 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Évaluation de la recherche des papillomavirus humains (HPV) en dépistage primaire des lésions précancéreuses et cancéreuses du col de l’utérus - HAS - 2019", -1))
const _hoisted_340 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_341 = { class: "toggle-info bg-green" }
const _hoisted_342 = /*#__PURE__*/_createTextVNode("Faire / Ne pas faire")
const _hoisted_343 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_344 = [
  _hoisted_342,
  _hoisted_343
]
const _hoisted_345 = { class: "toggle-info bg-gray" }
const _hoisted_346 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_347 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_348 = [
  _hoisted_346,
  _hoisted_347
]
const _hoisted_349 = { key: 13 }
const _hoisted_350 = { class: "resp-text orange" }
const _hoisted_351 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_352 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Colposcopie avec biospsie si anomalie", -1))
const _hoisted_353 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "*Prise en charge adaptée selon les recommandations HAS 2019", -1))
const _hoisted_354 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_355 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_356 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_357 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_358 = [
  _hoisted_356,
  _hoisted_357
]
const _hoisted_359 = ["id"]
const _hoisted_360 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small-info-content" }, "Arbre décisionnel extrait de l’outil pour la pratique « le dépistage du cancer du col en pratique », INCa 2020, selon les reco HAS 2019", -1))
const _hoisted_361 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_362 = { class: "toggle-info bg-green" }
const _hoisted_363 = /*#__PURE__*/_createTextVNode("Faire / Ne pas faire")
const _hoisted_364 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_365 = [
  _hoisted_363,
  _hoisted_364
]
const _hoisted_366 = { class: "toggle-info bg-gray" }
const _hoisted_367 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_368 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_369 = [
  _hoisted_367,
  _hoisted_368
]
const _hoisted_370 = { class: "toggle-info bg-pink" }
const _hoisted_371 = /*#__PURE__*/_createTextVNode("Prise en charge des cytologies anormales")
const _hoisted_372 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_373 = [
  _hoisted_371,
  _hoisted_372
]
const _hoisted_374 = { key: 14 }
const _hoisted_375 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Quel est le résultat de la "),
  /*#__PURE__*/_createElementVNode("strong", { class: "orange" }, "cytologie"),
  /*#__PURE__*/_createTextVNode(" anormale ?")
], -1))
const _hoisted_376 = { key: 15 }
const _hoisted_377 = { class: "resp-text orange" }
const _hoisted_378 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_379 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Colposcopie", -1))
const _hoisted_380 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_381 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_382 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_383 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_384 = [
  _hoisted_382,
  _hoisted_383
]
const _hoisted_385 = ["id"]
const _hoisted_386 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_387 = { class: "toggle-info bg-gray" }
const _hoisted_388 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_390 = [
  _hoisted_388,
  _hoisted_389
]
const _hoisted_391 = { key: 16 }
const _hoisted_392 = { class: "resp-text orange" }
const _hoisted_393 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_394 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Réaliser une colposcopie avec biopsie si anomalie", -1))
const _hoisted_395 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Quel est le résultat de la "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "colposcopie"),
  /*#__PURE__*/_createTextVNode(" ?")
], -1))
const _hoisted_396 = { class: "list-button-container" }
const _hoisted_397 = { key: 17 }
const _hoisted_398 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Colposcopie "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "normale"),
  /*#__PURE__*/_createTextVNode(" et satisfaisante")
], -1))
const _hoisted_399 = { class: "resp-text orange" }
const _hoisted_400 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_401 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Test HPV ou cytologie à 12 mois", -1))
const _hoisted_402 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_403 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_404 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_405 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_406 = [
  _hoisted_404,
  _hoisted_405
]
const _hoisted_407 = ["id"]
const _hoisted_408 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_409 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_410 = { class: "toggle-info bg-gray" }
const _hoisted_411 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_412 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_413 = [
  _hoisted_411,
  _hoisted_412
]
const _hoisted_414 = { key: 18 }
const _hoisted_415 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Colposcopie "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "anormale"),
  /*#__PURE__*/_createTextVNode(": lésion histo après biopsie")
], -1))
const _hoisted_416 = { class: "resp-text orange" }
const _hoisted_417 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_418 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Prise en charge selon les recommandations", -1))
const _hoisted_419 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_420 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_421 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Arbre décisionnel : lésion histo de "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "haut"),
  /*#__PURE__*/_createTextVNode(" grade")
], -1))
const _hoisted_422 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_423 = [
  _hoisted_421,
  _hoisted_422
]
const _hoisted_424 = ["id"]
const _hoisted_425 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_426 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_427 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_428 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Arbre décisionnel : lésion histo de "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "bas"),
  /*#__PURE__*/_createTextVNode(" grade")
], -1))
const _hoisted_429 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_430 = [
  _hoisted_428,
  _hoisted_429
]
const _hoisted_431 = ["id"]
const _hoisted_432 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_433 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_434 = { class: "toggle-info bg-gray" }
const _hoisted_435 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_436 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_437 = [
  _hoisted_435,
  _hoisted_436
]
const _hoisted_438 = { key: 19 }
const _hoisted_439 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Quel était le résultat de la précédente "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "colposcopie"),
  /*#__PURE__*/_createTextVNode(" ?")
], -1))
const _hoisted_440 = ["id"]
const _hoisted_441 = ["id"]
const _hoisted_442 = { key: 0 }
const _hoisted_443 = { class: "resp-text orange" }
const _hoisted_444 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_445 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Electrorésection à l'anse diathermique sous colposcopie", -1))
const _hoisted_446 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_447 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_448 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_449 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_450 = [
  _hoisted_448,
  _hoisted_449
]
const _hoisted_451 = ["id"]
const _hoisted_452 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_453 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_454 = { class: "toggle-info bg-gray" }
const _hoisted_455 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_456 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_457 = [
  _hoisted_455,
  _hoisted_456
]
const _hoisted_458 = { key: 1 }
const _hoisted_459 = { class: "resp-text orange" }
const _hoisted_460 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_461 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Exérèse haute", -1))
const _hoisted_462 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_463 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_464 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_465 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_466 = [
  _hoisted_464,
  _hoisted_465
]
const _hoisted_467 = ["id"]
const _hoisted_468 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_469 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_470 = { class: "toggle-info bg-gray" }
const _hoisted_471 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_472 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_473 = [
  _hoisted_471,
  _hoisted_472
]
const _hoisted_474 = { key: 20 }
const _hoisted_475 = { class: "resp-text orange" }
const _hoisted_476 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_477 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Réaliser une colposcopie avec biopsie si anomalie", -1))
const _hoisted_478 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Quel est le résultat de la "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "colposcopie"),
  /*#__PURE__*/_createTextVNode(" ?")
], -1))
const _hoisted_479 = { class: "list-button-container" }
const _hoisted_480 = { key: 21 }
const _hoisted_481 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Colposcopie "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "normale"),
  /*#__PURE__*/_createTextVNode(" et satisfaisante")
], -1))
const _hoisted_482 = { class: "resp-text orange" }
const _hoisted_483 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_484 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Test HPV ou cytologie à 12 mois", -1))
const _hoisted_485 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_486 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_487 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_488 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_489 = [
  _hoisted_487,
  _hoisted_488
]
const _hoisted_490 = ["id"]
const _hoisted_491 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_492 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_493 = { class: "toggle-info bg-gray" }
const _hoisted_494 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_495 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_496 = [
  _hoisted_494,
  _hoisted_495
]
const _hoisted_497 = { key: 22 }
const _hoisted_498 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Lésion "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "histo")
], -1))
const _hoisted_499 = { class: "resp-text orange" }
const _hoisted_500 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_501 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Prise en charge selon les recommandations", -1))
const _hoisted_502 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_503 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_504 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Arbre décisionnel : lésion histo de "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "haut"),
  /*#__PURE__*/_createTextVNode(" grade")
], -1))
const _hoisted_505 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_506 = [
  _hoisted_504,
  _hoisted_505
]
const _hoisted_507 = ["id"]
const _hoisted_508 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_509 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_510 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_511 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Arbre décisionnel : lésion histo de "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "bas"),
  /*#__PURE__*/_createTextVNode(" grade")
], -1))
const _hoisted_512 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_513 = [
  _hoisted_511,
  _hoisted_512
]
const _hoisted_514 = ["id"]
const _hoisted_515 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_516 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_517 = { class: "toggle-info bg-gray" }
const _hoisted_518 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_519 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_520 = [
  _hoisted_518,
  _hoisted_519
]
const _hoisted_521 = { key: 23 }
const _hoisted_522 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Colposcopie "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "non satisfaisante")
], -1))
const _hoisted_523 = { class: "resp-text orange" }
const _hoisted_524 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_525 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Colposcopie de controle et/ou curetage endocervical", -1))
const _hoisted_526 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_527 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_528 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_529 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_530 = [
  _hoisted_528,
  _hoisted_529
]
const _hoisted_531 = ["id"]
const _hoisted_532 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_533 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_534 = { class: "toggle-info bg-gray" }
const _hoisted_535 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_536 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_537 = [
  _hoisted_535,
  _hoisted_536
]
const _hoisted_538 = { key: 24 }
const _hoisted_539 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Précisez "),
  /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, "l'âge"),
  /*#__PURE__*/_createTextVNode(" de votre patiente :")
], -1))
const _hoisted_540 = { class: "row-button-container" }
const _hoisted_541 = ["id"]
const _hoisted_542 = ["id"]
const _hoisted_543 = { key: 0 }
const _hoisted_544 = { class: "resp-text orange" }
const _hoisted_545 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_546 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Exploration endo-utérine", -1))
const _hoisted_547 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_548 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_549 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_550 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_551 = [
  _hoisted_549,
  _hoisted_550
]
const _hoisted_552 = ["id"]
const _hoisted_553 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_554 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_555 = { class: "toggle-info bg-gray" }
const _hoisted_556 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_557 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_558 = [
  _hoisted_556,
  _hoisted_557
]
const _hoisted_559 = { key: 25 }
const _hoisted_560 = { class: "resp-text orange" }
const _hoisted_561 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_562 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Colposcopie et curetage endo-cervical", -1))
const _hoisted_563 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_564 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_565 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_566 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_567 = [
  _hoisted_565,
  _hoisted_566
]
const _hoisted_568 = ["id"]
const _hoisted_569 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_570 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_571 = { class: "toggle-info bg-gray" }
const _hoisted_572 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_573 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_574 = [
  _hoisted_572,
  _hoisted_573
]
const _hoisted_575 = { key: 26 }
const _hoisted_576 = { class: "resp-text orange" }
const _hoisted_577 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_578 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Colposcopie", -1))
const _hoisted_579 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_580 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_581 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_582 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_583 = [
  _hoisted_581,
  _hoisted_582
]
const _hoisted_584 = ["id"]
const _hoisted_585 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_586 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_587 = { class: "toggle-info bg-gray" }
const _hoisted_588 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_589 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_590 = [
  _hoisted_588,
  _hoisted_589
]
const _hoisted_591 = { key: 27 }
const _hoisted_592 = { class: "resp-text orange" }
const _hoisted_593 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_594 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Prise en charge selon les recommandations", -1))
const _hoisted_595 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_596 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_597 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_598 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_599 = [
  _hoisted_597,
  _hoisted_598
]
const _hoisted_600 = ["id"]
const _hoisted_601 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_602 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_603 = { class: "toggle-info bg-gray" }
const _hoisted_604 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_605 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_606 = [
  _hoisted_604,
  _hoisted_605
]
const _hoisted_607 = { key: 28 }
const _hoisted_608 = { class: "toggle-info bg-gray" }
const _hoisted_609 = /*#__PURE__*/_createTextVNode("Commentaire")
const _hoisted_610 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_611 = [
  _hoisted_609,
  _hoisted_610
]
const _hoisted_612 = ["id"]
const _hoisted_613 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Les patientes immunodéprimées ont un risque accrue de lésions virales et de cancers HPV induits.", -1))
const _hoisted_614 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Les données de la littérature sont limitées et le jugement clinique est important.", -1))
const _hoisted_615 = { class: "f-npf" }
const _hoisted_616 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Dans les recommandations HAS 2019, rythme et méthode de dépistage n’ont pas été évalués dans cette population spécifique. Toutefois, pour les femmes vivant avec le HIV ces dernières renvoies sur les recommandations actuelles du groupe d’experts Morlat « Prise en charge médicale des personnes vivant avec le VIH - Prévention et dépistage (avril 2018) » (https://cns.sante.fr/wp-content/uploads/2018/04/experts-vih_prevention-depistage.pdf). "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Il existe peu de données probantes permettant d’établir des recommandations spécifiques pour ces populations mais des avis d’experts ont été formulés en France qui préconisent pour ces femmes un dépistage cytologique plus régulier.")
  ])
], -1))
const _hoisted_617 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Pour la SFCPCV chez les femmes avec le VIH \"le frottis cytologique sera réalisé tous les trois ans si un traitement antirétroviral est mis en place, que la charge virale est indétectable et que le taux de CD4 est supérieur à 500 CD4/mm3. Dans tous les autres cas, un dépistage annuel est nécessaire\"")
], -1))
const _hoisted_618 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Aux USA le dépistage est à moduler en rythme et modalités selon le type d'immunodeppression (VIH ou immunodepression iatrogène) et l'âge", -1))
const _hoisted_619 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(- AB Moscicki et al Lower Genital Tract Diseases ,2019;23,2", -1))
const _hoisted_620 = /*#__PURE__*/_createTextVNode("- NHS ")
const _hoisted_621 = {
  key: 0,
  href: "https://hivinfo.nih.gov/",
  target: "blank",
  class: "dark"
}
const _hoisted_622 = {
  key: 1,
  href: "medics://viewer?m_source=https://hivinfo.nih.gov/",
  class: "dark"
}
const _hoisted_623 = { key: 29 }
const _hoisted_624 = { class: "toggle-info bg-gray" }
const _hoisted_625 = /*#__PURE__*/_createTextVNode("Commentaire")
const _hoisted_626 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_627 = [
  _hoisted_625,
  _hoisted_626
]
const _hoisted_628 = ["id"]
const _hoisted_629 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "L'étiologie du saignement doit etre déterminée par toutes les explorations d'usage (cytologie,colposcopie-biopsies,bactériologie, explorations endométriales, imagerie...)", -1))
const _hoisted_630 = [
  _hoisted_629
]
const _hoisted_631 = { key: 30 }
const _hoisted_632 = { class: "resp-text orange" }
const _hoisted_633 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_634 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Pratiquer un test HPV* 6 mois après la conisation ", -1))
const _hoisted_635 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small-reco" }, "* Test HPV haut risque réalisé dans une structure inscrite dans une démarche d’accréditation et avec un milieu de recueil de cellules et un test HPV validés", -1))
const _hoisted_636 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Quel est le résultat du "),
  /*#__PURE__*/_createElementVNode("span", { class: "orange" }, "test HPV"),
  /*#__PURE__*/_createTextVNode(" ?")
], -1))
const _hoisted_637 = { class: "row-button-container" }
const _hoisted_638 = ["id"]
const _hoisted_639 = ["id"]
const _hoisted_640 = { key: 0 }
const _hoisted_641 = { class: "resp-text orange" }
const _hoisted_642 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_643 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Colposcopie", -1))
const _hoisted_644 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_645 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_646 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_647 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_648 = [
  _hoisted_646,
  _hoisted_647
]
const _hoisted_649 = ["id"]
const _hoisted_650 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small-info-content" }, [
  /*#__PURE__*/_createTextVNode("* Test HPV haut risque réalisé dans une structure inscrite dans une démarche d’accréditation et avec un milieu de recueil de cellules et un test HPV validés. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("** Les données de la littérature ne permettent pas de recommander une attitude particulière, notamment une conisation diagnostique. Les outils existants (nouvelle colposcopie dans des conditions optimales, cytologie, curetage de l’endocol, test HPV) pourront être utilisés afin de décider de la conduite à tenir. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("*** Les données de la littérature ne permettent pas de déterminer exactement les modalités et périodicités de la surveillance prolongée. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("**** Si positif : colposcopie avec examen de la vulve et du vagin +/- biopsies. Si négatif : test HPV à 3 ans.")
], -1))
const _hoisted_651 = { class: "small-info-content" }
const _hoisted_652 = /*#__PURE__*/_createTextVNode("INCa 2019 - ")
const _hoisted_653 = ["href", "target"]
const _hoisted_654 = { key: 1 }
const _hoisted_655 = { class: "resp-text orange" }
const _hoisted_656 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_657 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Test HPV de contrôle à 3 ans", -1))
const _hoisted_658 = { key: 31 }
const _hoisted_659 = { class: "toggle-info bg-gray" }
const _hoisted_660 = /*#__PURE__*/_createTextVNode("Commentaire")
const _hoisted_661 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_662 = [
  _hoisted_660,
  _hoisted_661
]
const _hoisted_663 = ["id"]
const _hoisted_664 = /*#__PURE__*/_createStaticVNode("<p data-v-08c6623f>Il ne s&#39;agit plus de dépistage du cancer du col. Le dépistage ici a pour objectif de détecter des lésions vaginales de VaIN</p><p data-v-08c6623f>Ce dépistage se décline selon que :</p><p data-v-08c6623f>- la patiente a été hysterectomisée pour CINHG ou a un antecedant lointain de CIN HG</p><p data-v-08c6623f>-la patiente a eu une hysterectomie pour une autre raison qu&#39;une CIN HG</p><hr data-v-08c6623f><p data-v-08c6623f>Les données de la litterature sont limitées et ne permettent pas de determiner les modalités précises et la périodicité du suivi.</p><p data-v-08c6623f>Le risque de VaIN HG est plus élevé chez les femmes hysterectomisées pour CIN HG <em data-v-08c6623f>(Kah et al Gynecol Oncol 2016,;141:364-70)</em></p><ul class=\"tiret\" data-v-08c6623f><li data-v-08c6623f>Selon l&#39;InCa (recommandations 2019) lorsque l&#39;yysterectomie totale a été réalisée pour CIN HG le suivi est le meme que celui après conisation pour CIN HG : <br data-v-08c6623f>Test HPV de dépistage <ul data-v-08c6623f><li data-v-08c6623f>HPV negatif, dépistage HPV tout les 3 ans</li><li data-v-08c6623f>HPV positif, colposcopie</li></ul></li><li data-v-08c6623f>L&#39;American Cancer Society <em data-v-08c6623f>(https://www.cdc.gov/mmwr/preview/mmwrhtml/mm6151a3.htm#:~:text=CA%20Cancer%20J%20Clin%202012%3B62%3A147%E2%80%9372.)</em> et l&#39;American College of Gyn Obst <em data-v-08c6623f>(Obstet Gynecol 2012;120:1222–38)</em>, indiquent que :</li><ul data-v-08c6623f><li data-v-08c6623f>Hysterectomie totale non motivée par une CIN HG, le dépistage vaginal n&#39;est plus utile en particulier si il n&#39; y a pas eu de CIN HG durant les 25 années précédantes</li><li data-v-08c6623f>Hysterectomie pour CIN ou ADC in situ, poursuivre le dépistage jusqu&#39;à 20 ans et au dela de 65 ans</li></ul></ul>", 8)
const _hoisted_672 = [
  _hoisted_664
]
const _hoisted_673 = { key: 32 }
const _hoisted_674 = ["id"]
const _hoisted_675 = ["id"]
const _hoisted_676 = { key: 0 }
const _hoisted_677 = { class: "resp-text orange" }
const _hoisted_678 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_679 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Cytologie dans les 2 à 3 mois après l'accouchement", -1))
const _hoisted_680 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_681 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_682 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_683 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_684 = [
  _hoisted_682,
  _hoisted_683
]
const _hoisted_685 = ["id"]
const _hoisted_686 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_687 = { key: 1 }
const _hoisted_688 = { class: "resp-text orange" }
const _hoisted_689 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_690 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Colposcopie", -1))
const _hoisted_691 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_692 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_693 = /*#__PURE__*/_createTextVNode("Arbre décisionnel ")
const _hoisted_694 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_695 = [
  _hoisted_693,
  _hoisted_694
]
const _hoisted_696 = ["id"]
const _hoisted_697 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-content" }, "Conduite à tenir devant une femme ayant une cytologie cervico-utérine anormale – INCa – 2016", -1))
const _hoisted_698 = { key: 33 }
const _hoisted_699 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Quel est le"),
  /*#__PURE__*/_createElementVNode("span", { class: "fushia" }, " profil HPV"),
  /*#__PURE__*/_createTextVNode(" de votre patiente à 65 ans ?")
], -1))
const _hoisted_700 = { class: "row-button-container" }
const _hoisted_701 = { key: 34 }
const _hoisted_702 = { class: "toggle-info bg-gray" }
const _hoisted_703 = /*#__PURE__*/_createTextVNode("Commentaire")
const _hoisted_704 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_705 = [
  _hoisted_703,
  _hoisted_704
]
const _hoisted_706 = ["id"]
const _hoisted_707 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dépistage individuel à poursuivre après 65 ans dans les memes conditions que les femmes de moins de 65 ans. Prise en charge à adapter au cas par cas", -1))
const _hoisted_708 = [
  _hoisted_707
]
const _hoisted_709 = { key: 35 }
const _hoisted_710 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resp-text orange" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir"),
  /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Se référer à la même situation avant 65 ans")
], -1))
const _hoisted_711 = [
  _hoisted_710
]
const _hoisted_712 = { key: 36 }
const _hoisted_713 = { class: "resp-text orange" }
const _hoisted_714 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_715 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Test HPV à 1 an", -1))
const _hoisted_716 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pour en savoir plus, en pratique :", -1))
const _hoisted_717 = { class: "toggle-info bg-gray" }
const _hoisted_718 = /*#__PURE__*/_createTextVNode("Risque immédiat de CIN3+ (HPV +)")
const _hoisted_719 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_13 }, null, -1))
const _hoisted_720 = [
  _hoisted_718,
  _hoisted_719
]
const _hoisted_721 = { key: 37 }
const _hoisted_722 = { class: "resp-text orange" }
const _hoisted_723 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Conduite à tenir", -1))
const _hoisted_724 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "big-reco" }, "Le dépistage de routine n'est plus recommandé en France", -1))
const _hoisted_725 = { class: "toggle-info bg-gray" }
const _hoisted_726 = /*#__PURE__*/_createTextVNode("Commentaire")
const _hoisted_727 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_728 = [
  _hoisted_726,
  _hoisted_727
]
const _hoisted_729 = ["id"]
const _hoisted_730 = /*#__PURE__*/_createStaticVNode("<p data-v-08c6623f>La poursuite du dépistage après 65 ans est débattue dans la littérature scientifique.</p><p data-v-08c6623f>Les recommandations françaises (HAS 2019) indiquent que le dépistage n&#39;est plus recommandé après 65 ans. En effet le risque de développer un cancer du col chez les femmes de 65 ans HPV negatif est très faible compte tenu de la VPN élevée du test HPV negatif indiquant une protection durable et élevée. <em data-v-08c6623f>(Malagon T et al Lancet Oncology 2018,19:1569-78)</em></p><p data-v-08c6623f>Cependant le débat demeure sachant qu&#39;environ 20% des cancers du col sont observés après 65 ans <em data-v-08c6623f>(Gravitt P et al Prev Med 2018;114:188-94 - Feldman S et al J L Genit Tract Dis 2018,22:314-16)</em></p><p data-v-08c6623f>En France après 65 ans on observe, après une décroissance à la cinquantaine , une incidence qui augmente <em data-v-08c6623f>(Binder Foucard et al en ligne 2013)</em> et la participation au dépistage décline à 40% après 60 ans.</p><p data-v-08c6623f>Au cas par cas et selon le jugement clinique la poursuite du dépistage HPV <em data-v-08c6623f>(Rosenblatt KA et al 2016.142-:395-400)</em> pourrait se discuter si la patiente appartient à une population à risque.</p><p data-v-08c6623f>En particulier en cas :</p>", 6)
const _hoisted_736 = { class: "tiret" }
const _hoisted_737 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("d'antécédant de conisation pour CIN HG "),
  /*#__PURE__*/_createElementVNode("em", null, "(Strander B et al BMJ20072007; 335:1077)")
], -1))
const _hoisted_738 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("d'Immunodépression "),
  /*#__PURE__*/_createElementVNode("em", null, "(Moscicki AB et al J Low Genit Tract Dis 2019,2019, 23:87-101)")
], -1))
const _hoisted_739 = /*#__PURE__*/_createTextVNode("de risque d'etre exposée à l'HPV après 65 ans. (")
const _hoisted_740 = /*#__PURE__*/_createTextVNode("J Monsonego et al Vaccine 30 (2012) 5215–5221 - Nielsen A Sex Transm Dis. 2009 October ; 36(10): 609–615 - Lanner L et al PLoS One. 2020 Mar 20;15(3) - Hermansson RS PLoS One. 2018 Jan 10;13(1) - B Andersen Gynecol Oncol ")
const _hoisted_741 = ["href", "target"]
const _hoisted_742 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "reglementaire" }, "L’évaluation d’un patient est avant tout clinique et/ou biologique. Le traitement d’un patient ne peut reposer sur le seul résultat de cette application.")
], -1))
const _hoisted_743 = { class: "menu-container" }
const _hoisted_744 = { class: "menu-item-container" }
const _hoisted_745 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_746 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Accueil", -1))
const _hoisted_747 = [
  _hoisted_745,
  _hoisted_746
]
const _hoisted_748 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_749 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sources", -1))
const _hoisted_750 = [
  _hoisted_748,
  _hoisted_749
]
const _hoisted_751 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_752 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Références", -1))
const _hoisted_753 = [
  _hoisted_751,
  _hoisted_752
]
const _hoisted_754 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_755 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Définitions", -1))
const _hoisted_756 = [
  _hoisted_754,
  _hoisted_755
]
const _hoisted_757 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1))
const _hoisted_758 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Plus", -1))
const _hoisted_759 = [
  _hoisted_757,
  _hoisted_758
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sources = _resolveComponent("Sources")!
  const _component_References = _resolveComponent("References")!
  const _component_Definitions = _resolveComponent("Definitions")!
  const _component_Contexte = _resolveComponent("Contexte")!
  const _component_Remerciements = _resolveComponent("Remerciements")!
  const _component_Suggestions = _resolveComponent("Suggestions")!
  const _component_VoirSources = _resolveComponent("VoirSources")!
  const _component_RecoHas = _resolveComponent("RecoHas")!
  const _component_RecoInca = _resolveComponent("RecoInca")!
  const _component_PNGViewer = _resolveComponent("PNGViewer")!
  const _component_PNGViewerOrange = _resolveComponent("PNGViewerOrange")!
  const _component_Reco = _resolveComponent("Reco")!
  const _component_RecoHasSup65 = _resolveComponent("RecoHasSup65")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: (_ctx.nav !== '' || _ctx.item !== '') ? require('../assets/back.svg') : require('../assets/back-white.svg'),
          class: "small",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("img", {
        src: _imports_0,
        class: "cngof-logo",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
      }),
      _createElementVNode("img", {
        src: _imports_1,
        class: "cngof-logo2",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
      }),
      _createElementVNode("div", null, [
        (_ctx.isMobile())
          ? (_openBlock(), _createElementBlock("a", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true),
        (!_ctx.isMobile())
          ? (_openBlock(), _createElementBlock("span", _hoisted_7))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.item === 'sources')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_Sources)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'sommaire')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.hasAnsweredAge('0', '1', '< 25 ans', 'green'); _ctx.toggleItem('')})
              }, "Âge : avant 25 ans"),
              _createElementVNode("li", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.hasAnsweredAge('0', '2', '25-29 ans', 'orange'); _ctx.toggleItem('')})
              }, "Âge : 25 - 29 ans"),
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.goDirectlyTo({age: '25-29 ans', ageColor: 'orange', color: 'orange', keyword: 'Dépistage cytologique négatif (NILM)', navId: '0:2;2:7;'}); _ctx.toggleItem('')})
                }, "Cytologie CU : négative"),
                _createElementVNode("li", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.goDirectlyTo({age: '25-29 ans', ageColor: 'orange', color: 'fushia', keyword: 'ASCUS', navId: '0:2;2:1;'}); _ctx.toggleItem('')})
                }, "Cytologie CU : ASCUS"),
                _createElementVNode("li", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.goDirectlyTo({age: '25-29 ans', ageColor: 'orange', color: 'fushia', keyword: 'LSIL, ASCH ou HSIL', navId: '0:2;2:2;'}); _ctx.toggleItem('')})
                }, "Cytologie CU : LSIL, ASCH, HSIL"),
                _createElementVNode("li", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.goDirectlyTo({age: '25-29 ans', ageColor: 'orange', color: 'fushia', keyword: 'AGC', navId: '0:2;2:4;'}); _ctx.toggleItem('')})
                }, "Cytologie CU : AGC")
              ]),
              _createElementVNode("li", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.hasAnsweredAge('0', '3', '30-65 ans', 'orange'); _ctx.toggleItem('')})
              }, "Âge : 30 - 65 ans"),
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.goDirectlyTo({age: '30-65 ans', ageColor: 'orange', color: 'fushia', keyword: 'Dépistage de routine', navId: '0:3;1:1;'}); _ctx.toggleItem('')})
                }, "Dépistage de routine (HPV négatif ou HPV positif)"),
                _createElementVNode("li", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.hasAnsweredAge('0', '3', '30-65 ans', 'orange'); _ctx.toggleItem('')})
                }, "Dépistage en situations particulières"),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.goDirectlyTo({age: '30-65 ans', ageColor: 'orange', color: 'orange', keyword: 'Situation particulière : Patiente symptomatique (métrorragies provoquées ou spontanées ou col d\'aspect anormal)', navId: '0:3;1:2;'}); _ctx.toggleItem('')})
                  }, "Patientes Symptomatiques (métrorragies provoquées ou spontanées, col normal ou suspect)"),
                  _createElementVNode("li", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.goDirectlyTo({age: '30-65 ans', ageColor: 'orange', color: 'orange', keyword: 'Situation particulière : Patiente immunodéprimée', navId: '0:3;1:3;'}); _ctx.toggleItem('')})
                  }, "Patiente immunodéprimée"),
                  _createElementVNode("li", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.goDirectlyTo({age: '30-65 ans', ageColor: 'orange', color: 'orange', keyword: 'Situation particulière : Antécédent de CIN HG', navId: '0:3;1:4;'}); _ctx.toggleItem('')})
                  }, "Antécédents de CIN HG traitée"),
                  _createElementVNode("li", {
                    onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.goDirectlyTo({age: '30-65 ans', ageColor: 'orange', color: 'orange', keyword: 'Situation particulière : Grossesse', navId: '0:3;1:5;'}); _ctx.toggleItem('')})
                  }, "Grossesse"),
                  _createElementVNode("li", {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.goDirectlyTo({age: '30-65 ans', ageColor: 'orange', color: 'orange', keyword: 'Situation particulière : Hystérectomie totale', navId: '0:3;1:7;'}); _ctx.toggleItem('')})
                  }, "Hystérectomie totale")
                ])
              ]),
              _createElementVNode("li", {
                onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.hasAnsweredAge('0', '4', '65 ans', 'fushia'); _ctx.toggleItem('')})
              }, "Âge : 65 ans et plus")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item==='plus')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", {
              class: "sub-section",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, _hoisted_17),
            _createElementVNode("div", {
              class: "sub-section",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toggleItem('remerciements')))
            }, _hoisted_20),
            _createElementVNode("div", {
              class: "sub-section",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.toggleItem('contexte')))
            }, _hoisted_23),
            _createElementVNode("div", {
              class: "sub-section",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.toggleItem('sommaire')))
            }, _hoisted_26),
            _createElementVNode("div", {
              class: "sub-section",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toggleItem('sources')))
            }, _hoisted_29),
            _createElementVNode("div", {
              class: "sub-section",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.toggleItem('ref')))
            }, _hoisted_32),
            _createElementVNode("div", {
              class: "sub-section",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.toggleItem('def')))
            }, _hoisted_35),
            _createElementVNode("div", null, [
              (!_ctx.isMobile())
                ? (_openBlock(), _createElementBlock("a", _hoisted_36, _hoisted_39))
                : (_openBlock(), _createElementBlock("a", _hoisted_40, _hoisted_43))
            ]),
            _createElementVNode("div", {
              class: "sub-section",
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.toggleItem('sugg')))
            }, _hoisted_46)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'ref')
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createVNode(_component_References)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'def')
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createVNode(_component_Definitions)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'contexte')
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _createVNode(_component_Contexte)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'remerciements')
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createVNode(_component_Remerciements)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'sugg')
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createVNode(_component_Suggestions)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'ASCUS')
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createElementVNode("div", null, [
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _hoisted_56,
              _createVNode(_component_VoirSources)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'LSIL-ASCH-HSIL')
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("div", null, [
            _hoisted_58,
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              _createVNode(_component_VoirSources)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'AGC')
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
          _createElementVNode("div", null, [
            _hoisted_67,
            _createElementVNode("div", _hoisted_68, [
              _hoisted_69,
              _createVNode(_component_VoirSources)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'AIS')
      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
          _createElementVNode("div", null, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _hoisted_73,
              _createVNode(_component_VoirSources)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'cyto-neg')
      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
          _createElementVNode("div", null, [
            _hoisted_75,
            _createElementVNode("div", _hoisted_76, [
              _hoisted_77,
              _createVNode(_component_VoirSources)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'cyto-neg-sup-65')
      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
          _createElementVNode("div", null, [
            _hoisted_79,
            _createElementVNode("div", _hoisted_80, [
              _hoisted_81,
              _createVNode(_component_VoirSources)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'hpv-neg-sup-65')
      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
          _createElementVNode("div", null, [
            _hoisted_83,
            _createElementVNode("div", _hoisted_84, [
              _hoisted_85,
              _createVNode(_component_VoirSources)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'cyto-pos')
      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
          _createElementVNode("div", null, [
            _hoisted_87,
            _createElementVNode("div", _hoisted_88, [
              _hoisted_89,
              _createVNode(_component_VoirSources)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item === 'F-NPF-30-65-HPVneg')
      ? (_openBlock(), _createElementBlock("div", _hoisted_101, _hoisted_103))
      : _createCommentVNode("", true),
    (_ctx.item === 'F-NPF-30-65-HPVpos')
      ? (_openBlock(), _createElementBlock("div", _hoisted_104, _hoisted_106))
      : _createCommentVNode("", true),
    (_ctx.item === 'F-NPF-25-30')
      ? (_openBlock(), _createElementBlock("div", _hoisted_107, _hoisted_109))
      : _createCommentVNode("", true),
    (_ctx.item === '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 19,
          class: _normalizeClass(_ctx.nav === '' ? 'content-home' : 'content')
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_110, [
              (_ctx.nav !== '')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["age", _ctx.navigation.length > 0 ? _ctx.navigation[_ctx.navigation.length-1].color : _ctx.color ]),
                    onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
                  }, _toDisplayString(_ctx.age), 3))
                : _createCommentVNode("", true),
              (_ctx.nav !== '' && _ctx.nav !== '0:1;' && _ctx.nav !== '0:2;' && _ctx.nav !== '0:3;' && _ctx.nav !== '0:4;')
                ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["nav-block", `nav-${_ctx.navigation[_ctx.navigation.length-1].color}`])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (currentNav, id) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: id,
                          onClick: ($event: any) => (_ctx.showNav(currentNav)),
                          class: "nav-item"
                        }, "➔ " + _toDisplayString(currentNav.keyword), 9, _hoisted_112))
                      }), 128))
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.nav === '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("p", {
                      class: "preambule",
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.toggleItem('contexte')))
                    }, _hoisted_116),
                    _createElementVNode("p", {
                      class: "sommaire",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.toggleItem('sommaire'))),
                      onNavigate: _cache[29] || (_cache[29] = ($event: any) => (_ctx.goToNav($event)))
                    }, _hoisted_118, 32)
                  ]),
                  _hoisted_119,
                  _hoisted_120,
                  _hoisted_121,
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("button", {
                      class: "green age-button large-button",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.hasAnsweredAge('0', '1', 'avant 25 ans', 'green')))
                    }, " avant 25 ans"),
                    _createElementVNode("button", {
                      class: "blue age-button large-button",
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.hasAnsweredAge('0', '2', '25-29 ans', 'orange')))
                    }, " 25-29 ans"),
                    _createElementVNode("button", {
                      class: "orange age-button large-button",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.hasAnsweredAge('0', '3', '30-65 ans', 'orange')))
                    }, " 30-65 ans"),
                    _createElementVNode("button", {
                      class: "pink age-button large-button",
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.hasAnsweredAge('0', '4', 'après 65 ans', 'fushia')))
                    }, " après 65 ans")
                  ]),
                  _hoisted_123
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                  _hoisted_125,
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("p", {
                      class: "toggle-title small",
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                    }, _hoisted_129),
                    _createElementVNode("div", {
                      class: "toggled",
                      id: `${_ctx.nav}-1`
                    }, _hoisted_132, 8, _hoisted_130)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav=== '0:3;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                  _hoisted_134,
                  _createElementVNode("button", {
                    class: "orange medium-button",
                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.hasAnswered('1', '1', 'Dépistage de routine', 'fushia')))
                  }, _hoisted_138),
                  _hoisted_139,
                  _createElementVNode("button", {
                    class: "orange medium-button",
                    onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                  }, "Dépistage en situations particulières"),
                  _createElementVNode("div", {
                    class: "toggled",
                    id: `${_ctx.nav}-1`
                  }, [
                    _createElementVNode("button", {
                      class: "grey medium-small-button",
                      onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.hasAnswered('1', '2', 'Situation particulière : Patiente symptomatique (métrorragies provoquées ou spontanées ou col d\'aspect anormal)', 'orange')))
                    }, "Patiente symptomatique (métrorragies provoquées ou spontanées, col anormal ou suspect)"),
                    _createElementVNode("button", {
                      class: "grey medium-small-button",
                      onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.hasAnswered('1', '3', 'Situation particulière : Patiente immunodéprimée', 'orange')))
                    }, "Patiente immunodéprimée"),
                    _createElementVNode("button", {
                      class: "grey medium-small-button",
                      onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.hasAnswered('1', '4', 'Situation particulière : Antécédent de CIN HG', 'orange')))
                    }, "Antécédents de CIN HG traitée"),
                    _createElementVNode("button", {
                      class: "grey medium-small-button",
                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.hasAnswered('1', '5', 'Situation particulière : Grossesse', 'orange')))
                    }, "Grossesse"),
                    _createElementVNode("button", {
                      class: "grey medium-small-button",
                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.hasAnswered('1', '7', 'Situation particulière : Hystérectomie totale', 'orange')))
                    }, "Hystérectomie totale")
                  ], 8, _hoisted_140),
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-2`)))
                    }, _hoisted_144),
                    _createElementVNode("div", {
                      class: "toggled",
                      id: `${_ctx.nav}-2`
                    }, _hoisted_151, 8, _hoisted_145)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:2;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                  _hoisted_153,
                  _hoisted_154,
                  _createElementVNode("button", {
                    class: "orange list-button medium-button",
                    onClick: _cache[43] || (_cache[43] = ($event: any) => {_ctx.hasAnswered('2', '7', 'Dépistage cytologique négatif (NILM)', 'orange');})
                  }, "Négatif - (NILM)"),
                  _hoisted_155,
                  _createElementVNode("div", _hoisted_156, [
                    _createElementVNode("button", {
                      class: "orange list-button medium-button",
                      onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.hasAnswered('2', '1', 'ASCUS', 'fushia')))
                    }, "ASCUS"),
                    _createElementVNode("button", {
                      class: "orange list-button medium-button",
                      onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.hasAnswered('2', '2', 'LSIL, ASCH ou HSIL', 'fushia')))
                    }, "LSIL, ASCH ou HSIL"),
                    _createElementVNode("button", {
                      class: "orange list-button medium-button",
                      onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.hasAnswered('2', '4', 'AGC', 'fushia')))
                    }, "AGC")
                  ]),
                  _createElementVNode("div", _hoisted_157, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                    }, _hoisted_160),
                    _createElementVNode("div", {
                      class: "toggled",
                      id: `${_ctx.nav}-1`
                    }, _hoisted_167, 8, _hoisted_161)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:2;2:7;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                  _createElementVNode("div", _hoisted_169, [
                    _hoisted_170,
                    _hoisted_171,
                    _createVNode(_component_RecoHas)
                  ]),
                  _hoisted_172,
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.toggleItem('F-NPF-25-30')))
                    }, _hoisted_176)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:2;2:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                  _hoisted_178,
                  _createElementVNode("div", _hoisted_179, [
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-1`,
                      class: "pink row-button small-button",
                      onClick: _cache[49] || (_cache[49] = ($event: any) => {_ctx.showEnd('6', '2'); _ctx.toggleClicked(`${_ctx.nav}-but-1`)})
                    }, "Non", 8, _hoisted_180),
                    _createElementVNode("button", {
                      class: "pink row-button small-button",
                      onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.hasAnswered('6', '1', 'Test HPV', 'fushia')))
                    }, "Oui")
                  ]),
                  (_ctx.endNav === '0:2;2:1;6:2;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                        _hoisted_182,
                        _hoisted_183,
                        _createElementVNode("div", _hoisted_184, [
                          _createElementVNode("p", {
                            class: "toggle-title",
                            onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.toggleItem('F-NPF-25-30')))
                          }, _hoisted_187)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:2;2:1;6:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                  _hoisted_189,
                  _createElementVNode("div", _hoisted_190, [
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-1`,
                      class: "pink row-button small-button",
                      onClick: _cache[52] || (_cache[52] = ($event: any) => {_ctx.resetOther([`${_ctx.nav}-but-2`]); _ctx.showEnd('7', '1'); _ctx.toggleClicked(`${_ctx.nav}-but-1`)})
                    }, "Négatif", 8, _hoisted_191),
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-2`,
                      class: "pink row-button small-button",
                      onClick: _cache[53] || (_cache[53] = ($event: any) => {_ctx.resetOther([`${_ctx.nav}-but-1`]); _ctx.showEnd('7', '2'); _ctx.toggleClicked(`${_ctx.nav}-but-2`)})
                    }, "Positif", 8, _hoisted_192)
                  ]),
                  (_ctx.endNav === '0:2;2:1;6:1;7:1;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                        _createElementVNode("div", _hoisted_194, [
                          _hoisted_195,
                          _hoisted_196,
                          _createVNode(_component_RecoInca),
                          _hoisted_197,
                          _hoisted_198,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                            }, _hoisted_201),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.endNav}-1`
                            }, [
                              _hoisted_203,
                              _createVNode(_component_PNGViewer, {
                                src: '1BIS.jpg',
                                myID: 'img1bis'
                              }, null, 8, ["src"]),
                              _hoisted_204
                            ], 8, _hoisted_202)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.endNav === '0:2;2:1;6:1;7:2;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                        _createElementVNode("div", _hoisted_206, [
                          _hoisted_207,
                          _hoisted_208,
                          _createVNode(_component_RecoInca),
                          _hoisted_209,
                          _hoisted_210,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-2`)))
                            }, _hoisted_213),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.endNav}-2`
                            }, [
                              _hoisted_215,
                              _createVNode(_component_PNGViewer, {
                                src: 'arbresdecisionnelscngofAscus.jpg',
                                myID: 'imgAscus'
                              }, null, 8, ["src"]),
                              _hoisted_216
                            ], 8, _hoisted_214)
                          ])
                        ]),
                        _hoisted_217,
                        _createElementVNode("div", _hoisted_218, [
                          _createElementVNode("p", {
                            class: "toggle-title",
                            onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.toggleItem('ASCUS')))
                          }, _hoisted_221)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:2;2:2;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                  _createElementVNode("div", _hoisted_223, [
                    _hoisted_224,
                    _hoisted_225,
                    _createVNode(_component_RecoInca),
                    _hoisted_226,
                    _hoisted_227,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-2`)))
                      }, _hoisted_230),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-2`
                      }, [
                        _hoisted_232,
                        _createVNode(_component_PNGViewer, {
                          src: 'arbresdecisionnelscngofLsilAscHHsil.jpg',
                          myID: 'imgASCHLSILHSIL'
                        }, null, 8, ["src"]),
                        _hoisted_233
                      ], 8, _hoisted_231)
                    ])
                  ]),
                  _hoisted_234,
                  _createElementVNode("div", _hoisted_235, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.toggleItem('LSIL-ASCH-HSIL')))
                    }, _hoisted_238)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:2;2:4;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                  _hoisted_240,
                  _createElementVNode("div", _hoisted_241, [
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-1`,
                      class: "pink row-button small-button",
                      onClick: _cache[59] || (_cache[59] = ($event: any) => {_ctx.showEnd('6', '2'); _ctx.toggleClicked(`${_ctx.nav}-but-1`)})
                    }, "Non", 8, _hoisted_242),
                    _createElementVNode("button", {
                      class: "pink row-button small-button",
                      onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.hasAnswered('6', '1', 'Test HPV', 'fushia')))
                    }, "Oui")
                  ]),
                  (_ctx.endNav === '0:2;2:4;6:2;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                        _hoisted_244,
                        _hoisted_245,
                        _createElementVNode("div", _hoisted_246, [
                          _createElementVNode("p", {
                            class: "toggle-title",
                            onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.toggleItem('F-NPF-25-30')))
                          }, _hoisted_249)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:2;2:4;6:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_250, [
                  _hoisted_251,
                  _createElementVNode("div", _hoisted_252, [
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-1`,
                      class: "pink row-button small-button",
                      onClick: _cache[62] || (_cache[62] = ($event: any) => {_ctx.resetOther([`${_ctx.nav}-but-2`]); _ctx.showEnd('7', '1'); _ctx.toggleClicked(`${_ctx.nav}-but-1`)})
                    }, "Négatif", 8, _hoisted_253),
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-2`,
                      class: "pink row-button small-button",
                      onClick: _cache[63] || (_cache[63] = ($event: any) => {_ctx.resetOther([`${_ctx.nav}-but-1`]); _ctx.showEnd('7', '2'); _ctx.toggleClicked(`${_ctx.nav}-but-2`)})
                    }, "Positif", 8, _hoisted_254)
                  ]),
                  (_ctx.endNav === '0:2;2:4;6:1;7:1;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
                        _createElementVNode("div", _hoisted_256, [
                          _hoisted_257,
                          _hoisted_258,
                          _createVNode(_component_RecoInca),
                          _hoisted_259,
                          _hoisted_260,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                            }, _hoisted_263),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.nav}-1`
                            }, [
                              _hoisted_265,
                              _createVNode(_component_PNGViewer, {
                                src: '12.jpg',
                                myID: 'img12'
                              }, null, 8, ["src"]),
                              _hoisted_266
                            ], 8, _hoisted_264)
                          ])
                        ]),
                        _hoisted_267,
                        _createElementVNode("div", _hoisted_268, [
                          _createElementVNode("p", {
                            class: "toggle-title",
                            onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.toggleItem('AGC')))
                          }, _hoisted_271)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.endNav === '0:2;2:4;6:1;7:2;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_272, [
                        _createElementVNode("div", _hoisted_273, [
                          _hoisted_274,
                          _hoisted_275,
                          _createVNode(_component_RecoInca),
                          _hoisted_276,
                          _hoisted_277,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                            }, _hoisted_280),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.endNav}-1`
                            }, [
                              _hoisted_282,
                              _createVNode(_component_PNGViewer, {
                                src: '13.jpg',
                                myID: 'img13'
                              }, null, 8, ["src"]),
                              _hoisted_283
                            ], 8, _hoisted_281)
                          ])
                        ]),
                        _hoisted_284,
                        _createElementVNode("div", _hoisted_285, [
                          _createElementVNode("p", {
                            class: "toggle-title",
                            onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.toggleItem('AGC')))
                          }, _hoisted_288)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_289, [
                  _createElementVNode("div", _hoisted_290, [
                    _hoisted_291,
                    _hoisted_292,
                    _createVNode(_component_RecoHas)
                  ]),
                  _hoisted_293,
                  _createElementVNode("div", _hoisted_294, [
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-1`,
                      class: "pink row-button small-button",
                      onClick: _cache[68] || (_cache[68] = ($event: any) => {_ctx.showEnd('7', '1'); _ctx.toggleClicked(`${_ctx.nav}-but-1`)})
                    }, "Négatif", 8, _hoisted_295),
                    _createElementVNode("button", {
                      class: "pink row-button small-button",
                      onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.hasAnswered('7', '2', 'Test HPV positif', 'orange')))
                    }, "Positif")
                  ]),
                  (_ctx.endNav === '0:3;1:1;7:1;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_296, [
                        _createElementVNode("div", _hoisted_297, [
                          _hoisted_298,
                          _hoisted_299,
                          _createVNode(_component_RecoHas),
                          _hoisted_300,
                          _hoisted_301,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                            }, _hoisted_304),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.endNav}-1`
                            }, [
                              _hoisted_306,
                              _createVNode(_component_PNGViewerOrange, {
                                src: '103.png',
                                myID: 'img103'
                              }, null, 8, ["src"])
                            ], 8, _hoisted_305)
                          ])
                        ]),
                        _hoisted_307,
                        _createElementVNode("div", _hoisted_308, [
                          _createElementVNode("p", {
                            class: "toggle-title",
                            onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.toggleItem('F-NPF-30-65-HPVneg')))
                          }, _hoisted_311)
                        ]),
                        _createElementVNode("div", _hoisted_312, [
                          _createElementVNode("p", {
                            class: "toggle-title",
                            onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.toggleItem('AIS')))
                          }, _hoisted_315)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_316, [
                  _hoisted_317,
                  _createElementVNode("div", _hoisted_318, [
                    _hoisted_319,
                    _hoisted_320,
                    _createVNode(_component_RecoHas)
                  ]),
                  _hoisted_321,
                  _createElementVNode("div", _hoisted_322, [
                    _createElementVNode("button", {
                      class: "orange list-button medium-button",
                      onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.hasAnswered('13', '7', 'Triage cytologique négatif', 'fushia')))
                    }, "Négatif -"),
                    _hoisted_323,
                    _createElementVNode("button", {
                      class: "orange list-button medium-tall-button",
                      onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.hasAnswered('13', '8', 'ASCUS + ou anomalie plus sévère', 'blue')))
                    }, _hoisted_327)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:7;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_328, [
                  _hoisted_329,
                  _createElementVNode("div", _hoisted_330, [
                    _hoisted_331,
                    _hoisted_332,
                    _createVNode(_component_RecoHas),
                    _hoisted_333,
                    _hoisted_334,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-3`)))
                      }, _hoisted_337),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-3`
                      }, [
                        _hoisted_339,
                        _createVNode(_component_PNGViewerOrange, {
                          src: '62.png',
                          myID: 'img62'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_338)
                    ])
                  ]),
                  _hoisted_340,
                  _createElementVNode("div", _hoisted_341, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.toggleItem('F-NPF-30-65-HPVpos')))
                    }, _hoisted_344)
                  ]),
                  _createElementVNode("div", _hoisted_345, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.toggleItem('cyto-neg')))
                    }, _hoisted_348)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav==='0:3;1:1;7:2;13:8;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_349, [
                  _createElementVNode("div", _hoisted_350, [
                    _hoisted_351,
                    _hoisted_352,
                    _hoisted_353,
                    _createVNode(_component_RecoHas),
                    _hoisted_354,
                    _hoisted_355,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                      }, _hoisted_358),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.endNav}-1`
                      }, [
                        _createVNode(_component_PNGViewer, {
                          src: '3065.jpg',
                          myID: 'img3065'
                        }, null, 8, ["src"]),
                        _hoisted_360
                      ], 8, _hoisted_359)
                    ])
                  ]),
                  _hoisted_361,
                  _createElementVNode("div", _hoisted_362, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.toggleItem('F-NPF-30-65-HPVpos')))
                    }, _hoisted_365)
                  ]),
                  _createElementVNode("div", _hoisted_366, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                    }, _hoisted_369)
                  ]),
                  _createElementVNode("div", _hoisted_370, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.hasAnswered('100', '1', 'Prise en charge des cytologies anormales', 'orange')))
                    }, _hoisted_373)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_374, [
                  _hoisted_375,
                  _createElementVNode("button", {
                    class: "orange list-button medium-button",
                    onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.hasAnswered('13', '1', 'ASCUS', 'orange')))
                  }, "ASCUS"),
                  _createElementVNode("button", {
                    class: "orange list-button medium-button",
                    onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.hasAnswered('13', '2', 'LSIL', 'blue')))
                  }, "LSIL"),
                  _createElementVNode("button", {
                    class: "orange list-button medium-button",
                    onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.hasAnswered('13', '3', 'ASC-H', 'blue')))
                  }, "ASC-H"),
                  _createElementVNode("button", {
                    class: "orange list-button medium-button",
                    onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.hasAnswered('13', '4', 'AGC', 'fushia')))
                  }, "AGC"),
                  _createElementVNode("button", {
                    class: "orange list-button medium-button",
                    onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.hasAnswered('13', '5', 'HSIL', 'blue')))
                  }, "HSIL"),
                  _createElementVNode("button", {
                    class: "orange list-button medium-button",
                    onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.hasAnswered('13', '6', 'AIS', 'blue')))
                  }, "AIS")
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_376, [
                  _createElementVNode("div", _hoisted_377, [
                    _hoisted_378,
                    _hoisted_379,
                    _createVNode(_component_RecoHas),
                    _hoisted_380,
                    _hoisted_381,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                      }, _hoisted_384),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.endNav}-1`
                      }, [
                        _createVNode(_component_PNGViewerOrange, {
                          src: '201bis.png',
                          myID: 'img201bis'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_385)
                    ])
                  ]),
                  _hoisted_386,
                  _createElementVNode("div", _hoisted_387, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                    }, _hoisted_390)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:2;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_391, [
                  _createElementVNode("div", _hoisted_392, [
                    _hoisted_393,
                    _hoisted_394,
                    _createVNode(_component_RecoInca)
                  ]),
                  _hoisted_395,
                  _createElementVNode("div", _hoisted_396, [
                    _createElementVNode("button", {
                      class: "blue medium-button",
                      onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.hasAnswered('8', '1', 'Colposcopie normale', 'blue')))
                    }, "Normale et satisfaisante"),
                    _createElementVNode("button", {
                      class: "blue medium-button",
                      onClick: _cache[91] || (_cache[91] = ($event: any) => (_ctx.hasAnswered('8', '2', 'Lésion histo après biopsie', 'blue')))
                    }, " Anormale : lésion histo après biopsie")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:2;8:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_397, [
                  _hoisted_398,
                  _createElementVNode("div", _hoisted_399, [
                    _hoisted_400,
                    _hoisted_401,
                    _createVNode(_component_RecoInca),
                    _hoisted_402,
                    _hoisted_403,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                      }, _hoisted_406),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-1`
                      }, [
                        _hoisted_408,
                        _createVNode(_component_PNGViewer, {
                          src: '2bis.png',
                          myID: 'img2bis'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_407)
                    ])
                  ]),
                  _hoisted_409,
                  _createElementVNode("div", _hoisted_410, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[93] || (_cache[93] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                    }, _hoisted_413)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:2;8:2;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_414, [
                  _hoisted_415,
                  _createElementVNode("div", _hoisted_416, [
                    _hoisted_417,
                    _hoisted_418,
                    _createVNode(_component_RecoInca),
                    _hoisted_419,
                    _hoisted_420,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[94] || (_cache[94] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-3`)))
                      }, _hoisted_423),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-3`
                      }, [
                        _hoisted_425,
                        _createVNode(_component_PNGViewer, {
                          src: '52.png',
                          myID: 'img52'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_424)
                    ]),
                    _hoisted_426,
                    _hoisted_427,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[95] || (_cache[95] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                      }, _hoisted_430),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-1`
                      }, [
                        _hoisted_432,
                        _createVNode(_component_PNGViewer, {
                          src: '51.png',
                          myID: 'img51'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_431)
                    ])
                  ]),
                  _hoisted_433,
                  _createElementVNode("div", _hoisted_434, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[96] || (_cache[96] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                    }, _hoisted_437)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:2;8:2;9:2;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_438, [
                  _hoisted_439,
                  _createElementVNode("button", {
                    id: `${_ctx.nav}-but-1`,
                    class: "blue medium-button",
                    onClick: _cache[97] || (_cache[97] = ($event: any) => {_ctx.showEnd('5', '1'); _ctx.toggleClicked(`${_ctx.nav}-but-1`); _ctx.resetOther([`${_ctx.nav}-but-2`])})
                  }, "Colposcopie satisfaisante", 8, _hoisted_440),
                  _createElementVNode("button", {
                    id: `${_ctx.nav}-but-2`,
                    class: "blue medium-button",
                    onClick: _cache[98] || (_cache[98] = ($event: any) => {_ctx.showEnd('5', '2'); _ctx.toggleClicked(`${_ctx.nav}-but-2`); _ctx.resetOther([`${_ctx.nav}-but-1`])})
                  }, "Colposcopie non satisfaisante", 8, _hoisted_441),
                  (_ctx.endNav === '0:3;1:1;7:2;13:8;100:1;13:2;8:2;9:2;5:1;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_442, [
                        _createElementVNode("div", _hoisted_443, [
                          _hoisted_444,
                          _hoisted_445,
                          _createVNode(_component_RecoInca),
                          _hoisted_446,
                          _hoisted_447,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[99] || (_cache[99] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                            }, _hoisted_450),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.endNav}-1`
                            }, [
                              _hoisted_452,
                              _createVNode(_component_PNGViewer, {
                                src: '4-9.jpg',
                                myID: 'img4-9'
                              }, null, 8, ["src"])
                            ], 8, _hoisted_451)
                          ])
                        ]),
                        _hoisted_453,
                        _createElementVNode("div", _hoisted_454, [
                          _createElementVNode("p", {
                            class: "toggle-title",
                            onClick: _cache[100] || (_cache[100] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                          }, _hoisted_457)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.endNav === '0:3;1:1;7:2;13:8;100:1;13:2;8:2;9:2;5:2;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_458, [
                        _createElementVNode("div", _hoisted_459, [
                          _hoisted_460,
                          _hoisted_461,
                          _createVNode(_component_RecoInca),
                          _hoisted_462,
                          _hoisted_463,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[101] || (_cache[101] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                            }, _hoisted_466),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.endNav}-1`
                            }, [
                              _hoisted_468,
                              _createVNode(_component_PNGViewer, {
                                src: '5-10.jpg',
                                myID: 'img5-10'
                              }, null, 8, ["src"])
                            ], 8, _hoisted_467)
                          ])
                        ]),
                        _hoisted_469,
                        _createElementVNode("div", _hoisted_470, [
                          _createElementVNode("p", {
                            class: "toggle-title",
                            onClick: _cache[102] || (_cache[102] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                          }, _hoisted_473)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:3;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_474, [
                  _createElementVNode("div", _hoisted_475, [
                    _hoisted_476,
                    _hoisted_477,
                    _createVNode(_component_RecoInca)
                  ]),
                  _hoisted_478,
                  _createElementVNode("div", _hoisted_479, [
                    _createElementVNode("button", {
                      class: "blue medium-button",
                      onClick: _cache[103] || (_cache[103] = ($event: any) => (_ctx.hasAnswered('3', '1', 'Colposcopie normale', 'blue')))
                    }, "Colposcopie normale et satisfaisante"),
                    _createElementVNode("button", {
                      class: "blue medium-button",
                      onClick: _cache[104] || (_cache[104] = ($event: any) => (_ctx.hasAnswered('3', '2', 'Lésion histo', 'blue')))
                    }, "Lésion histo"),
                    _createElementVNode("button", {
                      class: "blue medium-button",
                      onClick: _cache[105] || (_cache[105] = ($event: any) => (_ctx.hasAnswered('3', '3', 'Colposcopie non satisfaisante', 'blue')))
                    }, "Colposcopie non satisfaisante")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:3;3:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_480, [
                  _hoisted_481,
                  _createElementVNode("div", _hoisted_482, [
                    _hoisted_483,
                    _hoisted_484,
                    _createVNode(_component_RecoInca),
                    _hoisted_485,
                    _hoisted_486,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[106] || (_cache[106] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                      }, _hoisted_489),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-1`
                      }, [
                        _hoisted_491,
                        _createVNode(_component_PNGViewer, {
                          src: '6.jpg',
                          myID: 'img6'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_490)
                    ])
                  ]),
                  _hoisted_492,
                  _createElementVNode("div", _hoisted_493, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[107] || (_cache[107] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                    }, _hoisted_496)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:3;3:2;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_497, [
                  _hoisted_498,
                  _createElementVNode("div", _hoisted_499, [
                    _hoisted_500,
                    _hoisted_501,
                    _createVNode(_component_RecoInca),
                    _hoisted_502,
                    _hoisted_503,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[108] || (_cache[108] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-3`)))
                      }, _hoisted_506),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-3`
                      }, [
                        _hoisted_508,
                        _createVNode(_component_PNGViewer, {
                          src: '54.png',
                          myID: 'img54'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_507)
                    ]),
                    _hoisted_509,
                    _hoisted_510,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[109] || (_cache[109] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                      }, _hoisted_513),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-1`
                      }, [
                        _hoisted_515,
                        _createVNode(_component_PNGViewer, {
                          src: '53.png',
                          myID: 'img53'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_514)
                    ])
                  ]),
                  _hoisted_516,
                  _createElementVNode("div", _hoisted_517, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[110] || (_cache[110] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                    }, _hoisted_520)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:3;3:3;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_521, [
                  _hoisted_522,
                  _createElementVNode("div", _hoisted_523, [
                    _hoisted_524,
                    _hoisted_525,
                    _createVNode(_component_RecoInca),
                    _hoisted_526,
                    _hoisted_527,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[111] || (_cache[111] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                      }, _hoisted_530),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-1`
                      }, [
                        _hoisted_532,
                        _createVNode(_component_PNGViewer, {
                          src: '11.jpg',
                          myID: 'img11'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_531)
                    ])
                  ]),
                  _hoisted_533,
                  _createElementVNode("div", _hoisted_534, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[112] || (_cache[112] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                    }, _hoisted_537)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:4;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_538, [
                  _hoisted_539,
                  _createElementVNode("div", _hoisted_540, [
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-1`,
                      class: "pink row-button small-button",
                      onClick: _cache[113] || (_cache[113] = ($event: any) => {_ctx.showEnd('16', '1'); _ctx.toggleClicked(`${_ctx.nav}-but-1`); _ctx.resetOther([`${_ctx.nav}-but-2`])})
                    }, "≤ 45 ans", 8, _hoisted_541),
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-2`,
                      class: "pink row-button small-button",
                      onClick: _cache[114] || (_cache[114] = ($event: any) => {_ctx.showEnd('16', '2'); _ctx.toggleClicked(`${_ctx.nav}-but-2`); _ctx.resetOther([`${_ctx.nav}-but-1`])})
                    }, "> 45 ans", 8, _hoisted_542)
                  ]),
                  (_ctx.endNav === '0:3;1:1;7:2;13:8;100:1;13:4;16:2;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_543, [
                        _createElementVNode("div", _hoisted_544, [
                          _hoisted_545,
                          _hoisted_546,
                          _createVNode(_component_RecoInca),
                          _hoisted_547,
                          _hoisted_548,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[115] || (_cache[115] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                            }, _hoisted_551),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.endNav}-1`
                            }, [
                              _hoisted_553,
                              _createVNode(_component_PNGViewer, {
                                src: '70.png',
                                myID: 'img301'
                              }, null, 8, ["src"])
                            ], 8, _hoisted_552)
                          ])
                        ]),
                        _hoisted_554,
                        _createElementVNode("div", _hoisted_555, [
                          _createElementVNode("p", {
                            class: "toggle-title",
                            onClick: _cache[116] || (_cache[116] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                          }, _hoisted_558)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.endNav === '0:3;1:1;7:2;13:8;100:1;13:4;16:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_559, [
                  _createElementVNode("div", _hoisted_560, [
                    _hoisted_561,
                    _hoisted_562,
                    _createVNode(_component_RecoInca),
                    _hoisted_563,
                    _hoisted_564,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[117] || (_cache[117] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                      }, _hoisted_567),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-1`
                      }, [
                        _hoisted_569,
                        _createVNode(_component_PNGViewer, {
                          src: '70bis.jpg',
                          myID: 'img70bis'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_568)
                    ])
                  ]),
                  _hoisted_570,
                  _createElementVNode("div", _hoisted_571, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[118] || (_cache[118] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                    }, _hoisted_574)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:5;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_575, [
                  _createElementVNode("div", _hoisted_576, [
                    _hoisted_577,
                    _hoisted_578,
                    _createVNode(_component_RecoInca),
                    _hoisted_579,
                    _hoisted_580,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[119] || (_cache[119] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                      }, _hoisted_583),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.endNav}-1`
                      }, [
                        _hoisted_585,
                        _createVNode(_component_PNGViewer, {
                          src: '55.png',
                          myID: 'img55'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_584)
                    ])
                  ]),
                  _hoisted_586,
                  _createElementVNode("div", _hoisted_587, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[120] || (_cache[120] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                    }, _hoisted_590)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:1;7:2;13:8;100:1;13:6;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_591, [
                  _createElementVNode("div", _hoisted_592, [
                    _hoisted_593,
                    _hoisted_594,
                    _createVNode(_component_RecoInca),
                    _hoisted_595,
                    _hoisted_596,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "toggle-title",
                        onClick: _cache[121] || (_cache[121] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                      }, _hoisted_599),
                      _createElementVNode("div", {
                        class: "toggled",
                        id: `${_ctx.nav}-1`
                      }, [
                        _hoisted_601,
                        _createVNode(_component_PNGViewer, {
                          src: '56.png',
                          myID: 'img56'
                        }, null, 8, ["src"])
                      ], 8, _hoisted_600)
                    ])
                  ]),
                  _hoisted_602,
                  _createElementVNode("div", _hoisted_603, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[122] || (_cache[122] = ($event: any) => (_ctx.toggleItem('cyto-pos')))
                    }, _hoisted_606)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:3;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_607, [
                  _createElementVNode("div", _hoisted_608, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[123] || (_cache[123] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-2`)))
                    }, _hoisted_611),
                    _createElementVNode("div", {
                      class: "toggled",
                      id: `${_ctx.nav}-2`
                    }, [
                      _hoisted_613,
                      _hoisted_614,
                      _createElementVNode("ul", _hoisted_615, [
                        _hoisted_616,
                        _hoisted_617,
                        _createElementVNode("li", null, [
                          _hoisted_618,
                          _hoisted_619,
                          _createElementVNode("p", null, [
                            _hoisted_620,
                            (!_ctx.isMobile())
                              ? (_openBlock(), _createElementBlock("a", _hoisted_621, "https://hivinfo.nih.gov/"))
                              : (_openBlock(), _createElementBlock("a", _hoisted_622, "https://hivinfo.nih.gov/)"))
                          ])
                        ])
                      ])
                    ], 8, _hoisted_612)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:2;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_623, [
                  _createElementVNode("div", _hoisted_624, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[124] || (_cache[124] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-2`)))
                    }, _hoisted_627),
                    _createElementVNode("div", {
                      class: "toggled",
                      id: `${_ctx.nav}-2`
                    }, _hoisted_630, 8, _hoisted_628)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:4;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_631, [
                  _createElementVNode("div", _hoisted_632, [
                    _hoisted_633,
                    _hoisted_634,
                    _createVNode(_component_Reco),
                    _hoisted_635
                  ]),
                  _hoisted_636,
                  _createElementVNode("div", _hoisted_637, [
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-1`,
                      class: "orange row-button small-button",
                      onClick: _cache[125] || (_cache[125] = ($event: any) => {_ctx.showEnd('16', '1'); _ctx.toggleClicked(`${_ctx.nav}-but-1`); _ctx.resetOther([`${_ctx.nav}-but-2`])})
                    }, "Négatif", 8, _hoisted_638),
                    _createElementVNode("button", {
                      id: `${_ctx.nav}-but-2`,
                      class: "orange row-button small-button",
                      onClick: _cache[126] || (_cache[126] = ($event: any) => {_ctx.showEnd('16', '2'); _ctx.toggleClicked(`${_ctx.nav}-but-2`); _ctx.resetOther([`${_ctx.nav}-but-1`])})
                    }, "Positif", 8, _hoisted_639)
                  ]),
                  (_ctx.endNav === '0:3;1:4;16:2;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_640, [
                        _createElementVNode("div", _hoisted_641, [
                          _hoisted_642,
                          _hoisted_643,
                          _createVNode(_component_Reco),
                          _hoisted_644,
                          _hoisted_645,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[127] || (_cache[127] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-1`)))
                            }, _hoisted_648),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.nav}-1`
                            }, [
                              _createVNode(_component_PNGViewer, {
                                src: 'algo.png',
                                myID: 'algo'
                              }, null, 8, ["src"]),
                              _hoisted_650,
                              _createElementVNode("p", _hoisted_651, [
                                _hoisted_652,
                                _createElementVNode("a", {
                                  class: "dark underline",
                                  href: _ctx.isMobile() ? 'medics://viewer?m_source=https://doc.360medics.com/assets/media/cngof/Synthesesurveillanceposttherapeutique.pdf' : 'https://doc.360medics.com/assets/media/cngof/Synthesesurveillanceposttherapeutique.pdf',
                                  target:  _ctx.isMobile() ? '' : '_blank'
                                }, "voir source (page 4)", 8, _hoisted_653)
                              ])
                            ], 8, _hoisted_649)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.endNav === '0:3;1:4;16:1;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_654, [
                        _createElementVNode("div", _hoisted_655, [
                          _hoisted_656,
                          _hoisted_657,
                          _createVNode(_component_Reco)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:7;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_658, [
                  _createElementVNode("div", _hoisted_659, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[128] || (_cache[128] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-2`)))
                    }, _hoisted_662),
                    _createElementVNode("div", {
                      class: "toggled",
                      id: `${_ctx.nav}-2`
                    }, _hoisted_672, 8, _hoisted_663)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:3;1:5;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_673, [
                  _createElementVNode("button", {
                    id: `${_ctx.nav}-but-1`,
                    class: "orange medium-button",
                    onClick: _cache[129] || (_cache[129] = ($event: any) => {_ctx.resetOther([`${_ctx.nav}-but-3`]); _ctx.showEnd('19', '1'); _ctx.toggleClicked(`${_ctx.nav}-but-1`)})
                  }, "ASCUS / LSIL", 8, _hoisted_674),
                  _createElementVNode("button", {
                    id: `${_ctx.nav}-but-3`,
                    class: "orange medium-button",
                    onClick: _cache[130] || (_cache[130] = ($event: any) => {_ctx.resetOther([`${_ctx.nav}-but-1`]); _ctx.showEnd('19', '2'); _ctx.toggleClicked(`${_ctx.nav}-but-3`)})
                  }, "ASC-H / AGC / HSIL", 8, _hoisted_675),
                  (_ctx.endNav === '0:3;1:5;19:1;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_676, [
                        _createElementVNode("div", _hoisted_677, [
                          _hoisted_678,
                          _hoisted_679,
                          _createVNode(_component_RecoInca),
                          _hoisted_680,
                          _hoisted_681,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[131] || (_cache[131] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                            }, _hoisted_684),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.endNav}-1`
                            }, [
                              _hoisted_686,
                              _createVNode(_component_PNGViewer, {
                                src: 'Gross1.jpg',
                                myID: 'imgGross1'
                              }, null, 8, ["src"])
                            ], 8, _hoisted_685)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.endNav === '0:3;1:5;19:2;')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_687, [
                        _createElementVNode("div", _hoisted_688, [
                          _hoisted_689,
                          _hoisted_690,
                          _createVNode(_component_RecoInca),
                          _hoisted_691,
                          _hoisted_692,
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "toggle-title",
                              onClick: _cache[132] || (_cache[132] = ($event: any) => (_ctx.toggleContent(`${_ctx.endNav}-1`)))
                            }, _hoisted_695),
                            _createElementVNode("div", {
                              class: "toggled",
                              id: `${_ctx.endNav}-1`
                            }, [
                              _hoisted_697,
                              _createVNode(_component_PNGViewer, {
                                src: 'Gross2.jpg',
                                myID: 'imgGross2'
                              }, null, 8, ["src"])
                            ], 8, _hoisted_696)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:4;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_698, [
                  _hoisted_699,
                  _createElementVNode("div", _hoisted_700, [
                    _createElementVNode("button", {
                      class: "pink row-button small-button",
                      onClick: _cache[133] || (_cache[133] = ($event: any) => (_ctx.hasAnswered('14', '2', 'HPV négatif', 'orange')))
                    }, "Négatif"),
                    _createElementVNode("button", {
                      class: "pink row-button small-button",
                      onClick: _cache[134] || (_cache[134] = ($event: any) => (_ctx.hasAnswered('14', '1', 'HPV positif', 'orange')))
                    }, "Positif")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:4;14:1;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_701, [
                  _createElementVNode("div", _hoisted_702, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[135] || (_cache[135] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-2`)))
                    }, _hoisted_705),
                    _createElementVNode("div", {
                      class: "toggled",
                      id: `${_ctx.nav}-2`
                    }, _hoisted_708, 8, _hoisted_706)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:4;14:1;13:8;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_709, _hoisted_711))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:4;14:1;13:7;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_712, [
                  _createElementVNode("div", _hoisted_713, [
                    _hoisted_714,
                    _hoisted_715,
                    _createVNode(_component_RecoHasSup65)
                  ]),
                  _hoisted_716,
                  _createElementVNode("div", _hoisted_717, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[136] || (_cache[136] = ($event: any) => (_ctx.toggleItem('cyto-neg-sup-65')))
                    }, _hoisted_720)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nav === '0:4;14:2;')
              ? (_openBlock(), _createElementBlock("div", _hoisted_721, [
                  _createElementVNode("div", _hoisted_722, [
                    _hoisted_723,
                    _hoisted_724,
                    _createVNode(_component_RecoHas)
                  ]),
                  _createElementVNode("div", _hoisted_725, [
                    _createElementVNode("p", {
                      class: "toggle-title",
                      onClick: _cache[137] || (_cache[137] = ($event: any) => (_ctx.toggleContent(`${_ctx.nav}-2`)))
                    }, _hoisted_728),
                    _createElementVNode("div", {
                      class: "toggled",
                      id: `${_ctx.nav}-2`
                    }, [
                      _hoisted_730,
                      _createElementVNode("ul", _hoisted_736, [
                        _hoisted_737,
                        _hoisted_738,
                        _createElementVNode("li", null, [
                          _hoisted_739,
                          _createElementVNode("em", null, [
                            _hoisted_740,
                            _createElementVNode("a", {
                              class: "dark",
                              href: _ctx.isMobile() ? 'medics://viewer?m_source=https://doi.org/10.1016/j.ygyno.2019.04.680' : 'https://doi.org/10.1016/j.ygyno.2019.04.680',
                              target: _ctx.isMobile() ? '' : '_blank'
                            }, "https://doi.org/10.1016/j.ygyno.2019.04.680 )", 8, _hoisted_741)
                          ])
                        ])
                      ])
                    ], 8, _hoisted_729)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_742
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_743, [
      (_ctx.nav !== '' || _ctx.item !== '')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "return-button grey",
            onClick: _cache[138] || (_cache[138] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, "⇦ Page précédente"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_744, [
        _createElementVNode("span", {
          onClick: _cache[139] || (_cache[139] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args))),
          class: "menu-item"
        }, _hoisted_747),
        _createElementVNode("span", {
          onClick: _cache[140] || (_cache[140] = ($event: any) => (_ctx.toggleItem('sources'))),
          class: "menu-item"
        }, _hoisted_750),
        _createElementVNode("span", {
          onClick: _cache[141] || (_cache[141] = ($event: any) => (_ctx.toggleItem('ref'))),
          class: "menu-item"
        }, _hoisted_753),
        _createElementVNode("span", {
          onClick: _cache[142] || (_cache[142] = ($event: any) => (_ctx.toggleItem('def'))),
          class: "menu-item"
        }, _hoisted_756),
        _createElementVNode("span", {
          onClick: _cache[143] || (_cache[143] = ($event: any) => (_ctx.toggleItem('plus'))),
          class: "menu-item"
        }, _hoisted_759)
      ])
    ])
  ]))
}